(function (i) {
  "use strict";
  typeof define == "function" && define.amd
    ? define(["jquery"], i)
    : typeof exports < "u"
    ? (module.exports = i(require("jquery")))
    : i(jQuery);
})(function (i) {
  "use strict";
  var e = window.Slick || {};
  ((e = (function () {
    var e2 = 0;
    return function (t, o) {
      var s,
        n = this;
      (n.defaults = {
        accessibility: !0,
        adaptiveHeight: !1,
        appendArrows: i(t),
        appendDots: i(t),
        arrows: !0,
        asNavFor: null,
        prevArrow:
          '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
        nextArrow:
          '<button class="slick-next" aria-label="Next" type="button">Next</button>',
        autoplay: !1,
        autoplaySpeed: 3e3,
        centerMode: !1,
        centerPadding: "50px",
        cssEase: "ease",
        customPaging: function (e3, t2) {
          return i('<button type="button" />').text(t2 + 1);
        },
        dots: !1,
        dotsClass: "slick-dots",
        draggable: !0,
        easing: "linear",
        edgeFriction: 0.35,
        fade: !1,
        focusOnSelect: !1,
        focusOnChange: !1,
        infinite: !0,
        initialSlide: 0,
        lazyLoad: "ondemand",
        mobileFirst: !1,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        pauseOnDotsHover: !1,
        respondTo: "window",
        responsive: null,
        rows: 1,
        rtl: !1,
        slide: "",
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: !0,
        swipeToSlide: !1,
        touchMove: !0,
        touchThreshold: 5,
        useCSS: !0,
        useTransform: !0,
        variableWidth: !1,
        vertical: !1,
        verticalSwiping: !1,
        waitForAnimate: !0,
        zIndex: 1e3,
      }),
        (n.initials = {
          animating: !1,
          dragging: !1,
          autoPlayTimer: null,
          currentDirection: 0,
          currentLeft: null,
          currentSlide: 0,
          direction: 1,
          $dots: null,
          listWidth: null,
          listHeight: null,
          loadIndex: 0,
          $nextArrow: null,
          $prevArrow: null,
          scrolling: !1,
          slideCount: null,
          slideWidth: null,
          $slideTrack: null,
          $slides: null,
          sliding: !1,
          slideOffset: 0,
          swipeLeft: null,
          swiping: !1,
          $list: null,
          touchObject: {},
          transformsEnabled: !1,
          unslicked: !1,
        }),
        i.extend(n, n.initials),
        (n.activeBreakpoint = null),
        (n.animType = null),
        (n.animProp = null),
        (n.breakpoints = []),
        (n.breakpointSettings = []),
        (n.cssTransitions = !1),
        (n.focussed = !1),
        (n.interrupted = !1),
        (n.hidden = "hidden"),
        (n.paused = !0),
        (n.positionProp = null),
        (n.respondTo = null),
        (n.rowCount = 1),
        (n.shouldClick = !0),
        (n.$slider = i(t)),
        (n.$slidesCache = null),
        (n.transformType = null),
        (n.transitionType = null),
        (n.visibilityChange = "visibilitychange"),
        (n.windowWidth = 0),
        (n.windowTimer = null),
        (s = i(t).data("slick") || {}),
        (n.options = i.extend({}, n.defaults, o, s)),
        (n.currentSlide = n.options.initialSlide),
        (n.originalSettings = n.options),
        document.mozHidden !== void 0
          ? ((n.hidden = "mozHidden"),
            (n.visibilityChange = "mozvisibilitychange"))
          : document.webkitHidden !== void 0 &&
            ((n.hidden = "webkitHidden"),
            (n.visibilityChange = "webkitvisibilitychange")),
        (n.autoPlay = i.proxy(n.autoPlay, n)),
        (n.autoPlayClear = i.proxy(n.autoPlayClear, n)),
        (n.autoPlayIterator = i.proxy(n.autoPlayIterator, n)),
        (n.changeSlide = i.proxy(n.changeSlide, n)),
        (n.clickHandler = i.proxy(n.clickHandler, n)),
        (n.selectHandler = i.proxy(n.selectHandler, n)),
        (n.setPosition = i.proxy(n.setPosition, n)),
        (n.swipeHandler = i.proxy(n.swipeHandler, n)),
        (n.dragHandler = i.proxy(n.dragHandler, n)),
        (n.keyHandler = i.proxy(n.keyHandler, n)),
        (n.instanceUid = e2++),
        (n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
        n.registerBreakpoints(),
        n.init(!0);
    };
  })()).prototype.activateADA = function () {
    this.$slideTrack
      .find(".slick-active")
      .attr({ "aria-hidden": "false" })
      .find("a, input, button, select")
      .attr({ tabindex: "0" });
  }),
    (e.prototype.addSlide = e.prototype.slickAdd =
      function (e2, t, o) {
        var s = this;
        if (typeof t == "boolean") (o = t), (t = null);
        else if (t < 0 || t >= s.slideCount) return !1;
        s.unload(),
          typeof t == "number"
            ? t === 0 && s.$slides.length === 0
              ? i(e2).appendTo(s.$slideTrack)
              : o
              ? i(e2).insertBefore(s.$slides.eq(t))
              : i(e2).insertAfter(s.$slides.eq(t))
            : o === !0
            ? i(e2).prependTo(s.$slideTrack)
            : i(e2).appendTo(s.$slideTrack),
          (s.$slides = s.$slideTrack.children(this.options.slide)),
          s.$slideTrack.children(this.options.slide).detach(),
          s.$slideTrack.append(s.$slides),
          s.$slides.each(function (e3, t2) {
            i(t2).attr("data-slick-index", e3);
          }),
          (s.$slidesCache = s.$slides),
          s.reinit();
      }),
    (e.prototype.animateHeight = function () {
      var i2 = this;
      if (
        i2.options.slidesToShow === 1 &&
        i2.options.adaptiveHeight === !0 &&
        i2.options.vertical === !1
      ) {
        var e2 = i2.$slides.eq(i2.currentSlide).outerHeight(!0);
        i2.$list.animate({ height: e2 }, i2.options.speed);
      }
    }),
    (e.prototype.animateSlide = function (e2, t) {
      var o = {},
        s = this;
      s.animateHeight(),
        s.options.rtl === !0 && s.options.vertical === !1 && (e2 = -e2),
        s.transformsEnabled === !1
          ? s.options.vertical === !1
            ? s.$slideTrack.animate(
                { left: e2 },
                s.options.speed,
                s.options.easing,
                t
              )
            : s.$slideTrack.animate(
                { top: e2 },
                s.options.speed,
                s.options.easing,
                t
              )
          : s.cssTransitions === !1
          ? (s.options.rtl === !0 && (s.currentLeft = -s.currentLeft),
            i({ animStart: s.currentLeft }).animate(
              { animStart: e2 },
              {
                duration: s.options.speed,
                easing: s.options.easing,
                step: function (i2) {
                  (i2 = Math.ceil(i2)),
                    s.options.vertical === !1
                      ? ((o[s.animType] = "translate(" + i2 + "px, 0px)"),
                        s.$slideTrack.css(o))
                      : ((o[s.animType] = "translate(0px," + i2 + "px)"),
                        s.$slideTrack.css(o));
                },
                complete: function () {
                  t && t.call();
                },
              }
            ))
          : (s.applyTransition(),
            (e2 = Math.ceil(e2)),
            s.options.vertical === !1
              ? (o[s.animType] = "translate3d(" + e2 + "px, 0px, 0px)")
              : (o[s.animType] = "translate3d(0px," + e2 + "px, 0px)"),
            s.$slideTrack.css(o),
            t &&
              setTimeout(function () {
                s.disableTransition(), t.call();
              }, s.options.speed));
    }),
    (e.prototype.getNavTarget = function () {
      var e2 = this,
        t = e2.options.asNavFor;
      return t && t !== null && (t = i(t).not(e2.$slider)), t;
    }),
    (e.prototype.asNavFor = function (e2) {
      var t = this.getNavTarget();
      t !== null &&
        typeof t == "object" &&
        t.each(function () {
          var t2 = i(this).slick("getSlick");
          t2.unslicked || t2.slideHandler(e2, !0);
        });
    }),
    (e.prototype.applyTransition = function (i2) {
      var e2 = this,
        t = {};
      e2.options.fade === !1
        ? (t[e2.transitionType] =
            e2.transformType +
            " " +
            e2.options.speed +
            "ms " +
            e2.options.cssEase)
        : (t[e2.transitionType] =
            "opacity " + e2.options.speed + "ms " + e2.options.cssEase),
        e2.options.fade === !1
          ? e2.$slideTrack.css(t)
          : e2.$slides.eq(i2).css(t);
    }),
    (e.prototype.autoPlay = function () {
      var i2 = this;
      i2.autoPlayClear(),
        i2.slideCount > i2.options.slidesToShow &&
          (i2.autoPlayTimer = setInterval(
            i2.autoPlayIterator,
            i2.options.autoplaySpeed
          ));
    }),
    (e.prototype.autoPlayClear = function () {
      var i2 = this;
      i2.autoPlayTimer && clearInterval(i2.autoPlayTimer);
    }),
    (e.prototype.autoPlayIterator = function () {
      var i2 = this,
        e2 = i2.currentSlide + i2.options.slidesToScroll;
      i2.paused ||
        i2.interrupted ||
        i2.focussed ||
        (i2.options.infinite === !1 &&
          (i2.direction === 1 && i2.currentSlide + 1 === i2.slideCount - 1
            ? (i2.direction = 0)
            : i2.direction === 0 &&
              ((e2 = i2.currentSlide - i2.options.slidesToScroll),
              i2.currentSlide - 1 == 0 && (i2.direction = 1))),
        i2.slideHandler(e2));
    }),
    (e.prototype.buildArrows = function () {
      var e2 = this;
      e2.options.arrows === !0 &&
        ((e2.$prevArrow = i(e2.options.prevArrow).addClass("slick-arrow")),
        (e2.$nextArrow = i(e2.options.nextArrow).addClass("slick-arrow")),
        e2.slideCount > e2.options.slidesToShow
          ? (e2.$prevArrow
              .removeClass("slick-hidden")
              .removeAttr("aria-hidden tabindex"),
            e2.$nextArrow
              .removeClass("slick-hidden")
              .removeAttr("aria-hidden tabindex"),
            e2.htmlExpr.test(e2.options.prevArrow) &&
              e2.$prevArrow.prependTo(e2.options.appendArrows),
            e2.htmlExpr.test(e2.options.nextArrow) &&
              e2.$nextArrow.appendTo(e2.options.appendArrows),
            e2.options.infinite !== !0 &&
              e2.$prevArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"))
          : e2.$prevArrow
              .add(e2.$nextArrow)
              .addClass("slick-hidden")
              .attr({ "aria-disabled": "true", tabindex: "-1" }));
    }),
    (e.prototype.buildDots = function () {
      var e2,
        t,
        o = this;
      if (o.options.dots === !0) {
        for (
          o.$slider.addClass("slick-dotted"),
            t = i("<ul />").addClass(o.options.dotsClass),
            e2 = 0;
          e2 <= o.getDotCount();
          e2 += 1
        )
          t.append(
            i("<li />").append(o.options.customPaging.call(this, o, e2))
          );
        (o.$dots = t.appendTo(o.options.appendDots)),
          o.$dots.find("li").first().addClass("slick-active");
      }
    }),
    (e.prototype.buildOut = function () {
      var e2 = this;
      (e2.$slides = e2.$slider
        .children(e2.options.slide + ":not(.slick-cloned)")
        .addClass("slick-slide")),
        (e2.slideCount = e2.$slides.length),
        e2.$slides.each(function (e3, t) {
          i(t)
            .attr("data-slick-index", e3)
            .data("originalStyling", i(t).attr("style") || "");
        }),
        e2.$slider.addClass("slick-slider"),
        (e2.$slideTrack =
          e2.slideCount === 0
            ? i('<div class="slick-track"/>').appendTo(e2.$slider)
            : e2.$slides.wrapAll('<div class="slick-track"/>').parent()),
        (e2.$list = e2.$slideTrack.wrap('<div class="slick-list"/>').parent()),
        e2.$slideTrack.css("opacity", 0),
        (e2.options.centerMode !== !0 && e2.options.swipeToSlide !== !0) ||
          (e2.options.slidesToScroll = 1),
        i("img[data-lazy]", e2.$slider).not("[src]").addClass("slick-loading"),
        e2.setupInfinite(),
        e2.buildArrows(),
        e2.buildDots(),
        e2.updateDots(),
        e2.setSlideClasses(
          typeof e2.currentSlide == "number" ? e2.currentSlide : 0
        ),
        e2.options.draggable === !0 && e2.$list.addClass("draggable");
    }),
    (e.prototype.buildRows = function () {
      var i2,
        e2,
        t,
        o,
        s,
        n,
        r,
        l = this;
      if (
        ((o = document.createDocumentFragment()),
        (n = l.$slider.children()),
        l.options.rows > 1)
      ) {
        for (
          r = l.options.slidesPerRow * l.options.rows,
            s = Math.ceil(n.length / r),
            i2 = 0;
          i2 < s;
          i2++
        ) {
          var d = document.createElement("div");
          for (e2 = 0; e2 < l.options.rows; e2++) {
            var a = document.createElement("div");
            for (t = 0; t < l.options.slidesPerRow; t++) {
              var c = i2 * r + (e2 * l.options.slidesPerRow + t);
              n.get(c) && a.appendChild(n.get(c));
            }
            d.appendChild(a);
          }
          o.appendChild(d);
        }
        l.$slider.empty().append(o),
          l.$slider
            .children()
            .children()
            .children()
            .css({
              width: 100 / l.options.slidesPerRow + "%",
              display: "inline-block",
            });
      }
    }),
    (e.prototype.checkResponsive = function (e2, t) {
      var o,
        s,
        n,
        r = this,
        l = !1,
        d = r.$slider.width(),
        a = window.innerWidth || i(window).width();
      if (
        (r.respondTo === "window"
          ? (n = a)
          : r.respondTo === "slider"
          ? (n = d)
          : r.respondTo === "min" && (n = Math.min(a, d)),
        r.options.responsive &&
          r.options.responsive.length &&
          r.options.responsive !== null)
      ) {
        s = null;
        for (o in r.breakpoints)
          r.breakpoints.hasOwnProperty(o) &&
            (r.originalSettings.mobileFirst === !1
              ? n < r.breakpoints[o] && (s = r.breakpoints[o])
              : n > r.breakpoints[o] && (s = r.breakpoints[o]));
        s !== null
          ? r.activeBreakpoint !== null
            ? (s !== r.activeBreakpoint || t) &&
              ((r.activeBreakpoint = s),
              r.breakpointSettings[s] === "unslick"
                ? r.unslick(s)
                : ((r.options = i.extend(
                    {},
                    r.originalSettings,
                    r.breakpointSettings[s]
                  )),
                  e2 === !0 && (r.currentSlide = r.options.initialSlide),
                  r.refresh(e2)),
              (l = s))
            : ((r.activeBreakpoint = s),
              r.breakpointSettings[s] === "unslick"
                ? r.unslick(s)
                : ((r.options = i.extend(
                    {},
                    r.originalSettings,
                    r.breakpointSettings[s]
                  )),
                  e2 === !0 && (r.currentSlide = r.options.initialSlide),
                  r.refresh(e2)),
              (l = s))
          : r.activeBreakpoint !== null &&
            ((r.activeBreakpoint = null),
            (r.options = r.originalSettings),
            e2 === !0 && (r.currentSlide = r.options.initialSlide),
            r.refresh(e2),
            (l = s)),
          e2 || l === !1 || r.$slider.trigger("breakpoint", [r, l]);
      }
    }),
    (e.prototype.changeSlide = function (e2, t) {
      var o,
        s,
        n,
        r = this,
        l = i(e2.currentTarget);
      switch (
        (l.is("a") && e2.preventDefault(),
        l.is("li") || (l = l.closest("li")),
        (n = r.slideCount % r.options.slidesToScroll != 0),
        (o = n
          ? 0
          : (r.slideCount - r.currentSlide) % r.options.slidesToScroll),
        e2.data.message)
      ) {
        case "previous":
          (s = o === 0 ? r.options.slidesToScroll : r.options.slidesToShow - o),
            r.slideCount > r.options.slidesToShow &&
              r.slideHandler(r.currentSlide - s, !1, t);
          break;
        case "next":
          (s = o === 0 ? r.options.slidesToScroll : o),
            r.slideCount > r.options.slidesToShow &&
              r.slideHandler(r.currentSlide + s, !1, t);
          break;
        case "index":
          var d =
            e2.data.index === 0
              ? 0
              : e2.data.index || l.index() * r.options.slidesToScroll;
          r.slideHandler(r.checkNavigable(d), !1, t),
            l.children().trigger("focus");
          break;
        default:
          return;
      }
    }),
    (e.prototype.checkNavigable = function (i2) {
      var e2, t;
      if (((e2 = this.getNavigableIndexes()), (t = 0), i2 > e2[e2.length - 1]))
        i2 = e2[e2.length - 1];
      else
        for (var o in e2) {
          if (i2 < e2[o]) {
            i2 = t;
            break;
          }
          t = e2[o];
        }
      return i2;
    }),
    (e.prototype.cleanUpEvents = function () {
      var e2 = this;
      e2.options.dots &&
        e2.$dots !== null &&
        (i("li", e2.$dots)
          .off("click.slick", e2.changeSlide)
          .off("mouseenter.slick", i.proxy(e2.interrupt, e2, !0))
          .off("mouseleave.slick", i.proxy(e2.interrupt, e2, !1)),
        e2.options.accessibility === !0 &&
          e2.$dots.off("keydown.slick", e2.keyHandler)),
        e2.$slider.off("focus.slick blur.slick"),
        e2.options.arrows === !0 &&
          e2.slideCount > e2.options.slidesToShow &&
          (e2.$prevArrow && e2.$prevArrow.off("click.slick", e2.changeSlide),
          e2.$nextArrow && e2.$nextArrow.off("click.slick", e2.changeSlide),
          e2.options.accessibility === !0 &&
            (e2.$prevArrow && e2.$prevArrow.off("keydown.slick", e2.keyHandler),
            e2.$nextArrow &&
              e2.$nextArrow.off("keydown.slick", e2.keyHandler))),
        e2.$list.off("touchstart.slick mousedown.slick", e2.swipeHandler),
        e2.$list.off("touchmove.slick mousemove.slick", e2.swipeHandler),
        e2.$list.off("touchend.slick mouseup.slick", e2.swipeHandler),
        e2.$list.off("touchcancel.slick mouseleave.slick", e2.swipeHandler),
        e2.$list.off("click.slick", e2.clickHandler),
        i(document).off(e2.visibilityChange, e2.visibility),
        e2.cleanUpSlideEvents(),
        e2.options.accessibility === !0 &&
          e2.$list.off("keydown.slick", e2.keyHandler),
        e2.options.focusOnSelect === !0 &&
          i(e2.$slideTrack).children().off("click.slick", e2.selectHandler),
        i(window).off(
          "orientationchange.slick.slick-" + e2.instanceUid,
          e2.orientationChange
        ),
        i(window).off("resize.slick.slick-" + e2.instanceUid, e2.resize),
        i("[draggable!=true]", e2.$slideTrack).off(
          "dragstart",
          e2.preventDefault
        ),
        i(window).off("load.slick.slick-" + e2.instanceUid, e2.setPosition);
    }),
    (e.prototype.cleanUpSlideEvents = function () {
      var e2 = this;
      e2.$list.off("mouseenter.slick", i.proxy(e2.interrupt, e2, !0)),
        e2.$list.off("mouseleave.slick", i.proxy(e2.interrupt, e2, !1));
    }),
    (e.prototype.cleanUpRows = function () {
      var i2,
        e2 = this;
      e2.options.rows > 1 &&
        ((i2 = e2.$slides.children().children()).removeAttr("style"),
        e2.$slider.empty().append(i2));
    }),
    (e.prototype.clickHandler = function (i2) {
      this.shouldClick === !1 &&
        (i2.stopImmediatePropagation(),
        i2.stopPropagation(),
        i2.preventDefault());
    }),
    (e.prototype.destroy = function (e2) {
      var t = this;
      t.autoPlayClear(),
        (t.touchObject = {}),
        t.cleanUpEvents(),
        i(".slick-cloned", t.$slider).detach(),
        t.$dots && t.$dots.remove(),
        t.$prevArrow &&
          t.$prevArrow.length &&
          (t.$prevArrow
            .removeClass("slick-disabled slick-arrow slick-hidden")
            .removeAttr("aria-hidden aria-disabled tabindex")
            .css("display", ""),
          t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
        t.$nextArrow &&
          t.$nextArrow.length &&
          (t.$nextArrow
            .removeClass("slick-disabled slick-arrow slick-hidden")
            .removeAttr("aria-hidden aria-disabled tabindex")
            .css("display", ""),
          t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
        t.$slides &&
          (t.$slides
            .removeClass(
              "slick-slide slick-active slick-center slick-visible slick-current"
            )
            .removeAttr("aria-hidden")
            .removeAttr("data-slick-index")
            .each(function () {
              i(this).attr("style", i(this).data("originalStyling"));
            }),
          t.$slideTrack.children(this.options.slide).detach(),
          t.$slideTrack.detach(),
          t.$list.detach(),
          t.$slider.append(t.$slides)),
        t.cleanUpRows(),
        t.$slider.removeClass("slick-slider"),
        t.$slider.removeClass("slick-initialized"),
        t.$slider.removeClass("slick-dotted"),
        (t.unslicked = !0),
        e2 || t.$slider.trigger("destroy", [t]);
    }),
    (e.prototype.disableTransition = function (i2) {
      var e2 = this,
        t = {};
      (t[e2.transitionType] = ""),
        e2.options.fade === !1
          ? e2.$slideTrack.css(t)
          : e2.$slides.eq(i2).css(t);
    }),
    (e.prototype.fadeSlide = function (i2, e2) {
      var t = this;
      t.cssTransitions === !1
        ? (t.$slides.eq(i2).css({ zIndex: t.options.zIndex }),
          t.$slides
            .eq(i2)
            .animate({ opacity: 1 }, t.options.speed, t.options.easing, e2))
        : (t.applyTransition(i2),
          t.$slides.eq(i2).css({ opacity: 1, zIndex: t.options.zIndex }),
          e2 &&
            setTimeout(function () {
              t.disableTransition(i2), e2.call();
            }, t.options.speed));
    }),
    (e.prototype.fadeSlideOut = function (i2) {
      var e2 = this;
      e2.cssTransitions === !1
        ? e2.$slides
            .eq(i2)
            .animate(
              { opacity: 0, zIndex: e2.options.zIndex - 2 },
              e2.options.speed,
              e2.options.easing
            )
        : (e2.applyTransition(i2),
          e2.$slides.eq(i2).css({ opacity: 0, zIndex: e2.options.zIndex - 2 }));
    }),
    (e.prototype.filterSlides = e.prototype.slickFilter =
      function (i2) {
        var e2 = this;
        i2 !== null &&
          ((e2.$slidesCache = e2.$slides),
          e2.unload(),
          e2.$slideTrack.children(this.options.slide).detach(),
          e2.$slidesCache.filter(i2).appendTo(e2.$slideTrack),
          e2.reinit());
      }),
    (e.prototype.focusHandler = function () {
      var e2 = this;
      e2.$slider
        .off("focus.slick blur.slick")
        .on("focus.slick blur.slick", "*", function (t) {
          t.stopImmediatePropagation();
          var o = i(this);
          setTimeout(function () {
            e2.options.pauseOnFocus &&
              ((e2.focussed = o.is(":focus")), e2.autoPlay());
          }, 0);
        });
    }),
    (e.prototype.getCurrent = e.prototype.slickCurrentSlide =
      function () {
        return this.currentSlide;
      }),
    (e.prototype.getDotCount = function () {
      var i2 = this,
        e2 = 0,
        t = 0,
        o = 0;
      if (i2.options.infinite === !0)
        if (i2.slideCount <= i2.options.slidesToShow) ++o;
        else
          for (; e2 < i2.slideCount; )
            ++o,
              (e2 = t + i2.options.slidesToScroll),
              (t +=
                i2.options.slidesToScroll <= i2.options.slidesToShow
                  ? i2.options.slidesToScroll
                  : i2.options.slidesToShow);
      else if (i2.options.centerMode === !0) o = i2.slideCount;
      else if (i2.options.asNavFor)
        for (; e2 < i2.slideCount; )
          ++o,
            (e2 = t + i2.options.slidesToScroll),
            (t +=
              i2.options.slidesToScroll <= i2.options.slidesToShow
                ? i2.options.slidesToScroll
                : i2.options.slidesToShow);
      else
        o =
          1 +
          Math.ceil(
            (i2.slideCount - i2.options.slidesToShow) /
              i2.options.slidesToScroll
          );
      return o - 1;
    }),
    (e.prototype.getLeft = function (i2) {
      var e2,
        t,
        o,
        s,
        n = this,
        r = 0;
      return (
        (n.slideOffset = 0),
        (t = n.$slides.first().outerHeight(!0)),
        n.options.infinite === !0
          ? (n.slideCount > n.options.slidesToShow &&
              ((n.slideOffset = n.slideWidth * n.options.slidesToShow * -1),
              (s = -1),
              n.options.vertical === !0 &&
                n.options.centerMode === !0 &&
                (n.options.slidesToShow === 2
                  ? (s = -1.5)
                  : n.options.slidesToShow === 1 && (s = -2)),
              (r = t * n.options.slidesToShow * s)),
            n.slideCount % n.options.slidesToScroll != 0 &&
              i2 + n.options.slidesToScroll > n.slideCount &&
              n.slideCount > n.options.slidesToShow &&
              (i2 > n.slideCount
                ? ((n.slideOffset =
                    (n.options.slidesToShow - (i2 - n.slideCount)) *
                    n.slideWidth *
                    -1),
                  (r = (n.options.slidesToShow - (i2 - n.slideCount)) * t * -1))
                : ((n.slideOffset =
                    (n.slideCount % n.options.slidesToScroll) *
                    n.slideWidth *
                    -1),
                  (r = (n.slideCount % n.options.slidesToScroll) * t * -1))))
          : i2 + n.options.slidesToShow > n.slideCount &&
            ((n.slideOffset =
              (i2 + n.options.slidesToShow - n.slideCount) * n.slideWidth),
            (r = (i2 + n.options.slidesToShow - n.slideCount) * t)),
        n.slideCount <= n.options.slidesToShow &&
          ((n.slideOffset = 0), (r = 0)),
        n.options.centerMode === !0 && n.slideCount <= n.options.slidesToShow
          ? (n.slideOffset =
              (n.slideWidth * Math.floor(n.options.slidesToShow)) / 2 -
              (n.slideWidth * n.slideCount) / 2)
          : n.options.centerMode === !0 && n.options.infinite === !0
          ? (n.slideOffset +=
              n.slideWidth * Math.floor(n.options.slidesToShow / 2) -
              n.slideWidth)
          : n.options.centerMode === !0 &&
            ((n.slideOffset = 0),
            (n.slideOffset +=
              n.slideWidth * Math.floor(n.options.slidesToShow / 2))),
        (e2 =
          n.options.vertical === !1
            ? i2 * n.slideWidth * -1 + n.slideOffset
            : i2 * t * -1 + r),
        n.options.variableWidth === !0 &&
          ((o =
            n.slideCount <= n.options.slidesToShow || n.options.infinite === !1
              ? n.$slideTrack.children(".slick-slide").eq(i2)
              : n.$slideTrack
                  .children(".slick-slide")
                  .eq(i2 + n.options.slidesToShow)),
          (e2 =
            n.options.rtl === !0
              ? o[0]
                ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                : 0
              : o[0]
              ? -1 * o[0].offsetLeft
              : 0),
          n.options.centerMode === !0 &&
            ((o =
              n.slideCount <= n.options.slidesToShow ||
              n.options.infinite === !1
                ? n.$slideTrack.children(".slick-slide").eq(i2)
                : n.$slideTrack
                    .children(".slick-slide")
                    .eq(i2 + n.options.slidesToShow + 1)),
            (e2 =
              n.options.rtl === !0
                ? o[0]
                  ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                  : 0
                : o[0]
                ? -1 * o[0].offsetLeft
                : 0),
            (e2 += (n.$list.width() - o.outerWidth()) / 2))),
        e2
      );
    }),
    (e.prototype.getOption = e.prototype.slickGetOption =
      function (i2) {
        return this.options[i2];
      }),
    (e.prototype.getNavigableIndexes = function () {
      var i2,
        e2 = this,
        t = 0,
        o = 0,
        s = [];
      for (
        e2.options.infinite === !1
          ? (i2 = e2.slideCount)
          : ((t = -1 * e2.options.slidesToScroll),
            (o = -1 * e2.options.slidesToScroll),
            (i2 = 2 * e2.slideCount));
        t < i2;

      )
        s.push(t),
          (t = o + e2.options.slidesToScroll),
          (o +=
            e2.options.slidesToScroll <= e2.options.slidesToShow
              ? e2.options.slidesToScroll
              : e2.options.slidesToShow);
      return s;
    }),
    (e.prototype.getSlick = function () {
      return this;
    }),
    (e.prototype.getSlideCount = function () {
      var e2,
        t,
        o = this;
      return (
        (t =
          o.options.centerMode === !0
            ? o.slideWidth * Math.floor(o.options.slidesToShow / 2)
            : 0),
        o.options.swipeToSlide === !0
          ? (o.$slideTrack.find(".slick-slide").each(function (s, n) {
              if (n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft)
                return (e2 = n), !1;
            }),
            Math.abs(i(e2).attr("data-slick-index") - o.currentSlide) || 1)
          : o.options.slidesToScroll
      );
    }),
    (e.prototype.goTo = e.prototype.slickGoTo =
      function (i2, e2) {
        this.changeSlide(
          { data: { message: "index", index: parseInt(i2) } },
          e2
        );
      }),
    (e.prototype.init = function (e2) {
      var t = this;
      i(t.$slider).hasClass("slick-initialized") ||
        (i(t.$slider).addClass("slick-initialized"),
        t.buildRows(),
        t.buildOut(),
        t.setProps(),
        t.startLoad(),
        t.loadSlider(),
        t.initializeEvents(),
        t.updateArrows(),
        t.updateDots(),
        t.checkResponsive(!0),
        t.focusHandler()),
        e2 && t.$slider.trigger("init", [t]),
        t.options.accessibility === !0 && t.initADA(),
        t.options.autoplay && ((t.paused = !1), t.autoPlay());
    }),
    (e.prototype.initADA = function () {
      var e2 = this,
        t = Math.ceil(e2.slideCount / e2.options.slidesToShow),
        o = e2.getNavigableIndexes().filter(function (i2) {
          return i2 >= 0 && i2 < e2.slideCount;
        });
      e2.$slides
        .add(e2.$slideTrack.find(".slick-cloned"))
        .attr({ "aria-hidden": "true", tabindex: "-1" })
        .find("a, input, button, select")
        .attr({ tabindex: "-1" }),
        e2.$dots !== null &&
          (e2.$slides
            .not(e2.$slideTrack.find(".slick-cloned"))
            .each(function (t2) {
              var s2 = o.indexOf(t2);
              i(this).attr({
                role: "tabpanel",
                id: "slick-slide" + e2.instanceUid + t2,
                tabindex: -1,
              }),
                s2 !== -1 &&
                  i(this).attr({
                    "aria-describedby":
                      "slick-slide-control" + e2.instanceUid + s2,
                  });
            }),
          e2.$dots
            .attr("role", "tablist")
            .find("li")
            .each(function (s2) {
              var n2 = o[s2];
              i(this).attr({ role: "presentation" }),
                i(this)
                  .find("button")
                  .first()
                  .attr({
                    role: "tab",
                    id: "slick-slide-control" + e2.instanceUid + s2,
                    "aria-controls": "slick-slide" + e2.instanceUid + n2,
                    "aria-label": s2 + 1 + " of " + t,
                    "aria-selected": null,
                    tabindex: "-1",
                  });
            })
            .eq(e2.currentSlide)
            .find("button")
            .attr({ "aria-selected": "true", tabindex: "0" })
            .end());
      for (var s = e2.currentSlide, n = s + e2.options.slidesToShow; s < n; s++)
        e2.$slides.eq(s).attr("tabindex", 0);
      e2.activateADA();
    }),
    (e.prototype.initArrowEvents = function () {
      var i2 = this;
      i2.options.arrows === !0 &&
        i2.slideCount > i2.options.slidesToShow &&
        (i2.$prevArrow
          .off("click.slick")
          .on("click.slick", { message: "previous" }, i2.changeSlide),
        i2.$nextArrow
          .off("click.slick")
          .on("click.slick", { message: "next" }, i2.changeSlide),
        i2.options.accessibility === !0 &&
          (i2.$prevArrow.on("keydown.slick", i2.keyHandler),
          i2.$nextArrow.on("keydown.slick", i2.keyHandler)));
    }),
    (e.prototype.initDotEvents = function () {
      var e2 = this;
      e2.options.dots === !0 &&
        (i("li", e2.$dots).on(
          "click.slick",
          { message: "index" },
          e2.changeSlide
        ),
        e2.options.accessibility === !0 &&
          e2.$dots.on("keydown.slick", e2.keyHandler)),
        e2.options.dots === !0 &&
          e2.options.pauseOnDotsHover === !0 &&
          i("li", e2.$dots)
            .on("mouseenter.slick", i.proxy(e2.interrupt, e2, !0))
            .on("mouseleave.slick", i.proxy(e2.interrupt, e2, !1));
    }),
    (e.prototype.initSlideEvents = function () {
      var e2 = this;
      e2.options.pauseOnHover &&
        (e2.$list.on("mouseenter.slick", i.proxy(e2.interrupt, e2, !0)),
        e2.$list.on("mouseleave.slick", i.proxy(e2.interrupt, e2, !1)));
    }),
    (e.prototype.initializeEvents = function () {
      var e2 = this;
      e2.initArrowEvents(),
        e2.initDotEvents(),
        e2.initSlideEvents(),
        e2.$list.on(
          "touchstart.slick mousedown.slick",
          { action: "start" },
          e2.swipeHandler
        ),
        e2.$list.on(
          "touchmove.slick mousemove.slick",
          { action: "move" },
          e2.swipeHandler
        ),
        e2.$list.on(
          "touchend.slick mouseup.slick",
          { action: "end" },
          e2.swipeHandler
        ),
        e2.$list.on(
          "touchcancel.slick mouseleave.slick",
          { action: "end" },
          e2.swipeHandler
        ),
        e2.$list.on("click.slick", e2.clickHandler),
        i(document).on(e2.visibilityChange, i.proxy(e2.visibility, e2)),
        e2.options.accessibility === !0 &&
          e2.$list.on("keydown.slick", e2.keyHandler),
        e2.options.focusOnSelect === !0 &&
          i(e2.$slideTrack).children().on("click.slick", e2.selectHandler),
        i(window).on(
          "orientationchange.slick.slick-" + e2.instanceUid,
          i.proxy(e2.orientationChange, e2)
        ),
        i(window).on(
          "resize.slick.slick-" + e2.instanceUid,
          i.proxy(e2.resize, e2)
        ),
        i("[draggable!=true]", e2.$slideTrack).on(
          "dragstart",
          e2.preventDefault
        ),
        i(window).on("load.slick.slick-" + e2.instanceUid, e2.setPosition),
        i(e2.setPosition);
    }),
    (e.prototype.initUI = function () {
      var i2 = this;
      i2.options.arrows === !0 &&
        i2.slideCount > i2.options.slidesToShow &&
        (i2.$prevArrow.show(), i2.$nextArrow.show()),
        i2.options.dots === !0 &&
          i2.slideCount > i2.options.slidesToShow &&
          i2.$dots.show();
    }),
    (e.prototype.keyHandler = function (i2) {
      var e2 = this;
      i2.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
        (i2.keyCode === 37 && e2.options.accessibility === !0
          ? e2.changeSlide({
              data: { message: e2.options.rtl === !0 ? "next" : "previous" },
            })
          : i2.keyCode === 39 &&
            e2.options.accessibility === !0 &&
            e2.changeSlide({
              data: { message: e2.options.rtl === !0 ? "previous" : "next" },
            }));
    }),
    (e.prototype.lazyLoad = function () {
      function e2(e3) {
        i("img[data-lazy]", e3).each(function () {
          var e4 = i(this),
            t2 = i(this).attr("data-lazy"),
            o2 = i(this).attr("data-srcset"),
            s2 = i(this).attr("data-sizes") || n.$slider.attr("data-sizes"),
            r2 = document.createElement("img");
          (r2.onload = function () {
            e4.animate({ opacity: 0 }, 100, function () {
              o2 && (e4.attr("srcset", o2), s2 && e4.attr("sizes", s2)),
                e4.attr("src", t2).animate({ opacity: 1 }, 200, function () {
                  e4.removeAttr("data-lazy data-srcset data-sizes").removeClass(
                    "slick-loading"
                  );
                }),
                n.$slider.trigger("lazyLoaded", [n, e4, t2]);
            });
          }),
            (r2.onerror = function () {
              e4
                .removeAttr("data-lazy")
                .removeClass("slick-loading")
                .addClass("slick-lazyload-error"),
                n.$slider.trigger("lazyLoadError", [n, e4, t2]);
            }),
            (r2.src = t2);
        });
      }
      var t,
        o,
        s,
        n = this;
      if (
        (n.options.centerMode === !0
          ? n.options.infinite === !0
            ? (s =
                (o = n.currentSlide + (n.options.slidesToShow / 2 + 1)) +
                n.options.slidesToShow +
                2)
            : ((o = Math.max(
                0,
                n.currentSlide - (n.options.slidesToShow / 2 + 1)
              )),
              (s = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide))
          : ((o = n.options.infinite
              ? n.options.slidesToShow + n.currentSlide
              : n.currentSlide),
            (s = Math.ceil(o + n.options.slidesToShow)),
            n.options.fade === !0 && (o > 0 && o--, s <= n.slideCount && s++)),
        (t = n.$slider.find(".slick-slide").slice(o, s)),
        n.options.lazyLoad === "anticipated")
      )
        for (
          var r = o - 1, l = s, d = n.$slider.find(".slick-slide"), a = 0;
          a < n.options.slidesToScroll;
          a++
        )
          r < 0 && (r = n.slideCount - 1),
            (t = (t = t.add(d.eq(r))).add(d.eq(l))),
            r--,
            l++;
      e2(t),
        n.slideCount <= n.options.slidesToShow
          ? e2(n.$slider.find(".slick-slide"))
          : n.currentSlide >= n.slideCount - n.options.slidesToShow
          ? e2(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow))
          : n.currentSlide === 0 &&
            e2(
              n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow)
            );
    }),
    (e.prototype.loadSlider = function () {
      var i2 = this;
      i2.setPosition(),
        i2.$slideTrack.css({ opacity: 1 }),
        i2.$slider.removeClass("slick-loading"),
        i2.initUI(),
        i2.options.lazyLoad === "progressive" && i2.progressiveLazyLoad();
    }),
    (e.prototype.next = e.prototype.slickNext =
      function () {
        this.changeSlide({ data: { message: "next" } });
      }),
    (e.prototype.orientationChange = function () {
      var i2 = this;
      i2.checkResponsive(), i2.setPosition();
    }),
    (e.prototype.pause = e.prototype.slickPause =
      function () {
        var i2 = this;
        i2.autoPlayClear(), (i2.paused = !0);
      }),
    (e.prototype.play = e.prototype.slickPlay =
      function () {
        var i2 = this;
        i2.autoPlay(),
          (i2.options.autoplay = !0),
          (i2.paused = !1),
          (i2.focussed = !1),
          (i2.interrupted = !1);
      }),
    (e.prototype.postSlide = function (e2) {
      var t = this;
      t.unslicked ||
        (t.$slider.trigger("afterChange", [t, e2]),
        (t.animating = !1),
        t.slideCount > t.options.slidesToShow && t.setPosition(),
        (t.swipeLeft = null),
        t.options.autoplay && t.autoPlay(),
        t.options.accessibility === !0 &&
          (t.initADA(),
          t.options.focusOnChange &&
            i(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()));
    }),
    (e.prototype.prev = e.prototype.slickPrev =
      function () {
        this.changeSlide({ data: { message: "previous" } });
      }),
    (e.prototype.preventDefault = function (i2) {
      i2.preventDefault();
    }),
    (e.prototype.progressiveLazyLoad = function (e2) {
      e2 = e2 || 1;
      var t,
        o,
        s,
        n,
        r,
        l = this,
        d = i("img[data-lazy]", l.$slider);
      d.length
        ? ((t = d.first()),
          (o = t.attr("data-lazy")),
          (s = t.attr("data-srcset")),
          (n = t.attr("data-sizes") || l.$slider.attr("data-sizes")),
          ((r = document.createElement("img")).onload = function () {
            s && (t.attr("srcset", s), n && t.attr("sizes", n)),
              t
                .attr("src", o)
                .removeAttr("data-lazy data-srcset data-sizes")
                .removeClass("slick-loading"),
              l.options.adaptiveHeight === !0 && l.setPosition(),
              l.$slider.trigger("lazyLoaded", [l, t, o]),
              l.progressiveLazyLoad();
          }),
          (r.onerror = function () {
            e2 < 3
              ? setTimeout(function () {
                  l.progressiveLazyLoad(e2 + 1);
                }, 500)
              : (t
                  .removeAttr("data-lazy")
                  .removeClass("slick-loading")
                  .addClass("slick-lazyload-error"),
                l.$slider.trigger("lazyLoadError", [l, t, o]),
                l.progressiveLazyLoad());
          }),
          (r.src = o))
        : l.$slider.trigger("allImagesLoaded", [l]);
    }),
    (e.prototype.refresh = function (e2) {
      var t,
        o,
        s = this;
      (o = s.slideCount - s.options.slidesToShow),
        !s.options.infinite && s.currentSlide > o && (s.currentSlide = o),
        s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0),
        (t = s.currentSlide),
        s.destroy(!0),
        i.extend(s, s.initials, { currentSlide: t }),
        s.init(),
        e2 || s.changeSlide({ data: { message: "index", index: t } }, !1);
    }),
    (e.prototype.registerBreakpoints = function () {
      var e2,
        t,
        o,
        s = this,
        n = s.options.responsive || null;
      if (i.type(n) === "array" && n.length) {
        s.respondTo = s.options.respondTo || "window";
        for (e2 in n)
          if (((o = s.breakpoints.length - 1), n.hasOwnProperty(e2))) {
            for (t = n[e2].breakpoint; o >= 0; )
              s.breakpoints[o] &&
                s.breakpoints[o] === t &&
                s.breakpoints.splice(o, 1),
                o--;
            s.breakpoints.push(t), (s.breakpointSettings[t] = n[e2].settings);
          }
        s.breakpoints.sort(function (i2, e3) {
          return s.options.mobileFirst ? i2 - e3 : e3 - i2;
        });
      }
    }),
    (e.prototype.reinit = function () {
      var e2 = this;
      (e2.$slides = e2.$slideTrack
        .children(e2.options.slide)
        .addClass("slick-slide")),
        (e2.slideCount = e2.$slides.length),
        e2.currentSlide >= e2.slideCount &&
          e2.currentSlide !== 0 &&
          (e2.currentSlide = e2.currentSlide - e2.options.slidesToScroll),
        e2.slideCount <= e2.options.slidesToShow && (e2.currentSlide = 0),
        e2.registerBreakpoints(),
        e2.setProps(),
        e2.setupInfinite(),
        e2.buildArrows(),
        e2.updateArrows(),
        e2.initArrowEvents(),
        e2.buildDots(),
        e2.updateDots(),
        e2.initDotEvents(),
        e2.cleanUpSlideEvents(),
        e2.initSlideEvents(),
        e2.checkResponsive(!1, !0),
        e2.options.focusOnSelect === !0 &&
          i(e2.$slideTrack).children().on("click.slick", e2.selectHandler),
        e2.setSlideClasses(
          typeof e2.currentSlide == "number" ? e2.currentSlide : 0
        ),
        e2.setPosition(),
        e2.focusHandler(),
        (e2.paused = !e2.options.autoplay),
        e2.autoPlay(),
        e2.$slider.trigger("reInit", [e2]);
    }),
    (e.prototype.resize = function () {
      var e2 = this;
      i(window).width() !== e2.windowWidth &&
        (clearTimeout(e2.windowDelay),
        (e2.windowDelay = window.setTimeout(function () {
          (e2.windowWidth = i(window).width()),
            e2.checkResponsive(),
            e2.unslicked || e2.setPosition();
        }, 50)));
    }),
    (e.prototype.removeSlide = e.prototype.slickRemove =
      function (i2, e2, t) {
        var o = this;
        if (
          ((i2 =
            typeof i2 == "boolean"
              ? (e2 = i2) === !0
                ? 0
                : o.slideCount - 1
              : e2 === !0
              ? --i2
              : i2),
          o.slideCount < 1 || i2 < 0 || i2 > o.slideCount - 1)
        )
          return !1;
        o.unload(),
          t === !0
            ? o.$slideTrack.children().remove()
            : o.$slideTrack.children(this.options.slide).eq(i2).remove(),
          (o.$slides = o.$slideTrack.children(this.options.slide)),
          o.$slideTrack.children(this.options.slide).detach(),
          o.$slideTrack.append(o.$slides),
          (o.$slidesCache = o.$slides),
          o.reinit();
      }),
    (e.prototype.setCSS = function (i2) {
      var e2,
        t,
        o = this,
        s = {};
      o.options.rtl === !0 && (i2 = -i2),
        (e2 = o.positionProp == "left" ? Math.ceil(i2) + "px" : "0px"),
        (t = o.positionProp == "top" ? Math.ceil(i2) + "px" : "0px"),
        (s[o.positionProp] = i2),
        o.transformsEnabled === !1
          ? o.$slideTrack.css(s)
          : ((s = {}),
            o.cssTransitions === !1
              ? ((s[o.animType] = "translate(" + e2 + ", " + t + ")"),
                o.$slideTrack.css(s))
              : ((s[o.animType] = "translate3d(" + e2 + ", " + t + ", 0px)"),
                o.$slideTrack.css(s)));
    }),
    (e.prototype.setDimensions = function () {
      var i2 = this;
      i2.options.vertical === !1
        ? i2.options.centerMode === !0 &&
          i2.$list.css({ padding: "0px " + i2.options.centerPadding })
        : (i2.$list.height(
            i2.$slides.first().outerHeight(!0) * i2.options.slidesToShow
          ),
          i2.options.centerMode === !0 &&
            i2.$list.css({ padding: i2.options.centerPadding + " 0px" })),
        (i2.listWidth = i2.$list.width()),
        (i2.listHeight = i2.$list.height()),
        i2.options.vertical === !1 && i2.options.variableWidth === !1
          ? ((i2.slideWidth = Math.ceil(
              i2.listWidth / i2.options.slidesToShow
            )),
            i2.$slideTrack.width(
              Math.ceil(
                i2.slideWidth * i2.$slideTrack.children(".slick-slide").length
              )
            ))
          : i2.options.variableWidth === !0
          ? i2.$slideTrack.width(5e3 * i2.slideCount)
          : ((i2.slideWidth = Math.ceil(i2.listWidth)),
            i2.$slideTrack.height(
              Math.ceil(
                i2.$slides.first().outerHeight(!0) *
                  i2.$slideTrack.children(".slick-slide").length
              )
            ));
      var e2 = i2.$slides.first().outerWidth(!0) - i2.$slides.first().width();
      i2.options.variableWidth === !1 &&
        i2.$slideTrack.children(".slick-slide").width(i2.slideWidth - e2);
    }),
    (e.prototype.setFade = function () {
      var e2,
        t = this;
      t.$slides.each(function (o, s) {
        (e2 = t.slideWidth * o * -1),
          t.options.rtl === !0
            ? i(s).css({
                position: "relative",
                right: e2,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0,
              })
            : i(s).css({
                position: "relative",
                left: e2,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0,
              });
      }),
        t.$slides
          .eq(t.currentSlide)
          .css({ zIndex: t.options.zIndex - 1, opacity: 1 });
    }),
    (e.prototype.setHeight = function () {
      var i2 = this;
      if (
        i2.options.slidesToShow === 1 &&
        i2.options.adaptiveHeight === !0 &&
        i2.options.vertical === !1
      ) {
        var e2 = i2.$slides.eq(i2.currentSlide).outerHeight(!0);
        i2.$list.css("height", e2);
      }
    }),
    (e.prototype.setOption = e.prototype.slickSetOption =
      function () {
        var e2,
          t,
          o,
          s,
          n,
          r = this,
          l = !1;
        if (
          (i.type(arguments[0]) === "object"
            ? ((o = arguments[0]), (l = arguments[1]), (n = "multiple"))
            : i.type(arguments[0]) === "string" &&
              ((o = arguments[0]),
              (s = arguments[1]),
              (l = arguments[2]),
              arguments[0] === "responsive" && i.type(arguments[1]) === "array"
                ? (n = "responsive")
                : arguments[1] !== void 0 && (n = "single")),
          n === "single")
        )
          r.options[o] = s;
        else if (n === "multiple")
          i.each(o, function (i2, e3) {
            r.options[i2] = e3;
          });
        else if (n === "responsive")
          for (t in s)
            if (i.type(r.options.responsive) !== "array")
              r.options.responsive = [s[t]];
            else {
              for (e2 = r.options.responsive.length - 1; e2 >= 0; )
                r.options.responsive[e2].breakpoint === s[t].breakpoint &&
                  r.options.responsive.splice(e2, 1),
                  e2--;
              r.options.responsive.push(s[t]);
            }
        l && (r.unload(), r.reinit());
      }),
    (e.prototype.setPosition = function () {
      var i2 = this;
      i2.setDimensions(),
        i2.setHeight(),
        i2.options.fade === !1
          ? i2.setCSS(i2.getLeft(i2.currentSlide))
          : i2.setFade(),
        i2.$slider.trigger("setPosition", [i2]);
    }),
    (e.prototype.setProps = function () {
      var i2 = this,
        e2 = document.body.style;
      (i2.positionProp = i2.options.vertical === !0 ? "top" : "left"),
        i2.positionProp === "top"
          ? i2.$slider.addClass("slick-vertical")
          : i2.$slider.removeClass("slick-vertical"),
        (e2.WebkitTransition === void 0 &&
          e2.MozTransition === void 0 &&
          e2.msTransition === void 0) ||
          (i2.options.useCSS === !0 && (i2.cssTransitions = !0)),
        i2.options.fade &&
          (typeof i2.options.zIndex == "number"
            ? i2.options.zIndex < 3 && (i2.options.zIndex = 3)
            : (i2.options.zIndex = i2.defaults.zIndex)),
        e2.OTransform !== void 0 &&
          ((i2.animType = "OTransform"),
          (i2.transformType = "-o-transform"),
          (i2.transitionType = "OTransition"),
          e2.perspectiveProperty === void 0 &&
            e2.webkitPerspective === void 0 &&
            (i2.animType = !1)),
        e2.MozTransform !== void 0 &&
          ((i2.animType = "MozTransform"),
          (i2.transformType = "-moz-transform"),
          (i2.transitionType = "MozTransition"),
          e2.perspectiveProperty === void 0 &&
            e2.MozPerspective === void 0 &&
            (i2.animType = !1)),
        e2.webkitTransform !== void 0 &&
          ((i2.animType = "webkitTransform"),
          (i2.transformType = "-webkit-transform"),
          (i2.transitionType = "webkitTransition"),
          e2.perspectiveProperty === void 0 &&
            e2.webkitPerspective === void 0 &&
            (i2.animType = !1)),
        e2.msTransform !== void 0 &&
          ((i2.animType = "msTransform"),
          (i2.transformType = "-ms-transform"),
          (i2.transitionType = "msTransition"),
          e2.msTransform === void 0 && (i2.animType = !1)),
        e2.transform !== void 0 &&
          i2.animType !== !1 &&
          ((i2.animType = "transform"),
          (i2.transformType = "transform"),
          (i2.transitionType = "transition")),
        (i2.transformsEnabled =
          i2.options.useTransform &&
          i2.animType !== null &&
          i2.animType !== !1);
    }),
    (e.prototype.setSlideClasses = function (i2) {
      var e2,
        t,
        o,
        s,
        n = this;
      if (
        ((t = n.$slider
          .find(".slick-slide")
          .removeClass("slick-active slick-center slick-current")
          .attr("aria-hidden", "true")),
        n.$slides.eq(i2).addClass("slick-current"),
        n.options.centerMode === !0)
      ) {
        var r = n.options.slidesToShow % 2 == 0 ? 1 : 0;
        (e2 = Math.floor(n.options.slidesToShow / 2)),
          n.options.infinite === !0 &&
            (i2 >= e2 && i2 <= n.slideCount - 1 - e2
              ? n.$slides
                  .slice(i2 - e2 + r, i2 + e2 + 1)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")
              : ((o = n.options.slidesToShow + i2),
                t
                  .slice(o - e2 + 1 + r, o + e2 + 2)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")),
            i2 === 0
              ? t
                  .eq(t.length - 1 - n.options.slidesToShow)
                  .addClass("slick-center")
              : i2 === n.slideCount - 1 &&
                t.eq(n.options.slidesToShow).addClass("slick-center")),
          n.$slides.eq(i2).addClass("slick-center");
      } else
        i2 >= 0 && i2 <= n.slideCount - n.options.slidesToShow
          ? n.$slides
              .slice(i2, i2 + n.options.slidesToShow)
              .addClass("slick-active")
              .attr("aria-hidden", "false")
          : t.length <= n.options.slidesToShow
          ? t.addClass("slick-active").attr("aria-hidden", "false")
          : ((s = n.slideCount % n.options.slidesToShow),
            (o = n.options.infinite === !0 ? n.options.slidesToShow + i2 : i2),
            n.options.slidesToShow == n.options.slidesToScroll &&
            n.slideCount - i2 < n.options.slidesToShow
              ? t
                  .slice(o - (n.options.slidesToShow - s), o + s)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")
              : t
                  .slice(o, o + n.options.slidesToShow)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false"));
      (n.options.lazyLoad !== "ondemand" &&
        n.options.lazyLoad !== "anticipated") ||
        n.lazyLoad();
    }),
    (e.prototype.setupInfinite = function () {
      var e2,
        t,
        o,
        s = this;
      if (
        (s.options.fade === !0 && (s.options.centerMode = !1),
        s.options.infinite === !0 &&
          s.options.fade === !1 &&
          ((t = null), s.slideCount > s.options.slidesToShow))
      ) {
        for (
          o =
            s.options.centerMode === !0
              ? s.options.slidesToShow + 1
              : s.options.slidesToShow,
            e2 = s.slideCount;
          e2 > s.slideCount - o;
          e2 -= 1
        )
          (t = e2 - 1),
            i(s.$slides[t])
              .clone(!0)
              .attr("id", "")
              .attr("data-slick-index", t - s.slideCount)
              .prependTo(s.$slideTrack)
              .addClass("slick-cloned");
        for (e2 = 0; e2 < o + s.slideCount; e2 += 1)
          (t = e2),
            i(s.$slides[t])
              .clone(!0)
              .attr("id", "")
              .attr("data-slick-index", t + s.slideCount)
              .appendTo(s.$slideTrack)
              .addClass("slick-cloned");
        s.$slideTrack
          .find(".slick-cloned")
          .find("[id]")
          .each(function () {
            i(this).attr("id", "");
          });
      }
    }),
    (e.prototype.interrupt = function (i2) {
      var e2 = this;
      i2 || e2.autoPlay(), (e2.interrupted = i2);
    }),
    (e.prototype.selectHandler = function (e2) {
      var t = this,
        o = i(e2.target).is(".slick-slide")
          ? i(e2.target)
          : i(e2.target).parents(".slick-slide"),
        s = parseInt(o.attr("data-slick-index"));
      s || (s = 0),
        t.slideCount <= t.options.slidesToShow
          ? t.slideHandler(s, !1, !0)
          : t.slideHandler(s);
    }),
    (e.prototype.slideHandler = function (i2, e2, t) {
      var o,
        s,
        n,
        r,
        l,
        d = null,
        a = this;
      if (
        ((e2 = e2 || !1),
        !(
          (a.animating === !0 && a.options.waitForAnimate === !0) ||
          (a.options.fade === !0 && a.currentSlide === i2)
        ))
      )
        if (
          (e2 === !1 && a.asNavFor(i2),
          (o = i2),
          (d = a.getLeft(o)),
          (r = a.getLeft(a.currentSlide)),
          (a.currentLeft = a.swipeLeft === null ? r : a.swipeLeft),
          a.options.infinite === !1 &&
            a.options.centerMode === !1 &&
            (i2 < 0 || i2 > a.getDotCount() * a.options.slidesToScroll))
        )
          a.options.fade === !1 &&
            ((o = a.currentSlide),
            t !== !0
              ? a.animateSlide(r, function () {
                  a.postSlide(o);
                })
              : a.postSlide(o));
        else if (
          a.options.infinite === !1 &&
          a.options.centerMode === !0 &&
          (i2 < 0 || i2 > a.slideCount - a.options.slidesToScroll)
        )
          a.options.fade === !1 &&
            ((o = a.currentSlide),
            t !== !0
              ? a.animateSlide(r, function () {
                  a.postSlide(o);
                })
              : a.postSlide(o));
        else {
          if (
            (a.options.autoplay && clearInterval(a.autoPlayTimer),
            (s =
              o < 0
                ? a.slideCount % a.options.slidesToScroll != 0
                  ? a.slideCount - (a.slideCount % a.options.slidesToScroll)
                  : a.slideCount + o
                : o >= a.slideCount
                ? a.slideCount % a.options.slidesToScroll != 0
                  ? 0
                  : o - a.slideCount
                : o),
            (a.animating = !0),
            a.$slider.trigger("beforeChange", [a, a.currentSlide, s]),
            (n = a.currentSlide),
            (a.currentSlide = s),
            a.setSlideClasses(a.currentSlide),
            a.options.asNavFor &&
              (l = (l = a.getNavTarget()).slick("getSlick")).slideCount <=
                l.options.slidesToShow &&
              l.setSlideClasses(a.currentSlide),
            a.updateDots(),
            a.updateArrows(),
            a.options.fade === !0)
          )
            return (
              t !== !0
                ? (a.fadeSlideOut(n),
                  a.fadeSlide(s, function () {
                    a.postSlide(s);
                  }))
                : a.postSlide(s),
              void a.animateHeight()
            );
          t !== !0
            ? a.animateSlide(d, function () {
                a.postSlide(s);
              })
            : a.postSlide(s);
        }
    }),
    (e.prototype.startLoad = function () {
      var i2 = this;
      i2.options.arrows === !0 &&
        i2.slideCount > i2.options.slidesToShow &&
        (i2.$prevArrow.hide(), i2.$nextArrow.hide()),
        i2.options.dots === !0 &&
          i2.slideCount > i2.options.slidesToShow &&
          i2.$dots.hide(),
        i2.$slider.addClass("slick-loading");
    }),
    (e.prototype.swipeDirection = function () {
      var i2,
        e2,
        t,
        o,
        s = this;
      return (
        (i2 = s.touchObject.startX - s.touchObject.curX),
        (e2 = s.touchObject.startY - s.touchObject.curY),
        (t = Math.atan2(e2, i2)),
        (o = Math.round((180 * t) / Math.PI)) < 0 && (o = 360 - Math.abs(o)),
        (o <= 45 && o >= 0) || (o <= 360 && o >= 315)
          ? s.options.rtl === !1
            ? "left"
            : "right"
          : o >= 135 && o <= 225
          ? s.options.rtl === !1
            ? "right"
            : "left"
          : s.options.verticalSwiping === !0
          ? o >= 35 && o <= 135
            ? "down"
            : "up"
          : "vertical"
      );
    }),
    (e.prototype.swipeEnd = function (i2) {
      var e2,
        t,
        o = this;
      if (((o.dragging = !1), (o.swiping = !1), o.scrolling))
        return (o.scrolling = !1), !1;
      if (
        ((o.interrupted = !1),
        (o.shouldClick = !(o.touchObject.swipeLength > 10)),
        o.touchObject.curX === void 0)
      )
        return !1;
      if (
        (o.touchObject.edgeHit === !0 &&
          o.$slider.trigger("edge", [o, o.swipeDirection()]),
        o.touchObject.swipeLength >= o.touchObject.minSwipe)
      ) {
        switch ((t = o.swipeDirection())) {
          case "left":
          case "down":
            (e2 = o.options.swipeToSlide
              ? o.checkNavigable(o.currentSlide + o.getSlideCount())
              : o.currentSlide + o.getSlideCount()),
              (o.currentDirection = 0);
            break;
          case "right":
          case "up":
            (e2 = o.options.swipeToSlide
              ? o.checkNavigable(o.currentSlide - o.getSlideCount())
              : o.currentSlide - o.getSlideCount()),
              (o.currentDirection = 1);
        }
        t != "vertical" &&
          (o.slideHandler(e2),
          (o.touchObject = {}),
          o.$slider.trigger("swipe", [o, t]));
      } else
        o.touchObject.startX !== o.touchObject.curX &&
          (o.slideHandler(o.currentSlide), (o.touchObject = {}));
    }),
    (e.prototype.swipeHandler = function (i2) {
      var e2 = this;
      if (
        !(
          e2.options.swipe === !1 ||
          ("ontouchend" in document && e2.options.swipe === !1) ||
          (e2.options.draggable === !1 && i2.type.indexOf("mouse") !== -1)
        )
      )
        switch (
          ((e2.touchObject.fingerCount =
            i2.originalEvent && i2.originalEvent.touches !== void 0
              ? i2.originalEvent.touches.length
              : 1),
          (e2.touchObject.minSwipe = e2.listWidth / e2.options.touchThreshold),
          e2.options.verticalSwiping === !0 &&
            (e2.touchObject.minSwipe =
              e2.listHeight / e2.options.touchThreshold),
          i2.data.action)
        ) {
          case "start":
            e2.swipeStart(i2);
            break;
          case "move":
            e2.swipeMove(i2);
            break;
          case "end":
            e2.swipeEnd(i2);
        }
    }),
    (e.prototype.swipeMove = function (i2) {
      var e2,
        t,
        o,
        s,
        n,
        r,
        l = this;
      return (
        (n = i2.originalEvent !== void 0 ? i2.originalEvent.touches : null),
        !(!l.dragging || l.scrolling || (n && n.length !== 1)) &&
          ((e2 = l.getLeft(l.currentSlide)),
          (l.touchObject.curX = n !== void 0 ? n[0].pageX : i2.clientX),
          (l.touchObject.curY = n !== void 0 ? n[0].pageY : i2.clientY),
          (l.touchObject.swipeLength = Math.round(
            Math.sqrt(Math.pow(l.touchObject.curX - l.touchObject.startX, 2))
          )),
          (r = Math.round(
            Math.sqrt(Math.pow(l.touchObject.curY - l.touchObject.startY, 2))
          )),
          !l.options.verticalSwiping && !l.swiping && r > 4
            ? ((l.scrolling = !0), !1)
            : (l.options.verticalSwiping === !0 &&
                (l.touchObject.swipeLength = r),
              (t = l.swipeDirection()),
              i2.originalEvent !== void 0 &&
                l.touchObject.swipeLength > 4 &&
                ((l.swiping = !0), i2.preventDefault()),
              (s =
                (l.options.rtl === !1 ? 1 : -1) *
                (l.touchObject.curX > l.touchObject.startX ? 1 : -1)),
              l.options.verticalSwiping === !0 &&
                (s = l.touchObject.curY > l.touchObject.startY ? 1 : -1),
              (o = l.touchObject.swipeLength),
              (l.touchObject.edgeHit = !1),
              l.options.infinite === !1 &&
                ((l.currentSlide === 0 && t === "right") ||
                  (l.currentSlide >= l.getDotCount() && t === "left")) &&
                ((o = l.touchObject.swipeLength * l.options.edgeFriction),
                (l.touchObject.edgeHit = !0)),
              l.options.vertical === !1
                ? (l.swipeLeft = e2 + o * s)
                : (l.swipeLeft = e2 + o * (l.$list.height() / l.listWidth) * s),
              l.options.verticalSwiping === !0 && (l.swipeLeft = e2 + o * s),
              l.options.fade !== !0 &&
                l.options.touchMove !== !1 &&
                (l.animating === !0
                  ? ((l.swipeLeft = null), !1)
                  : void l.setCSS(l.swipeLeft))))
      );
    }),
    (e.prototype.swipeStart = function (i2) {
      var e2,
        t = this;
      if (
        ((t.interrupted = !0),
        t.touchObject.fingerCount !== 1 ||
          t.slideCount <= t.options.slidesToShow)
      )
        return (t.touchObject = {}), !1;
      i2.originalEvent !== void 0 &&
        i2.originalEvent.touches !== void 0 &&
        (e2 = i2.originalEvent.touches[0]),
        (t.touchObject.startX = t.touchObject.curX =
          e2 !== void 0 ? e2.pageX : i2.clientX),
        (t.touchObject.startY = t.touchObject.curY =
          e2 !== void 0 ? e2.pageY : i2.clientY),
        (t.dragging = !0);
    }),
    (e.prototype.unfilterSlides = e.prototype.slickUnfilter =
      function () {
        var i2 = this;
        i2.$slidesCache !== null &&
          (i2.unload(),
          i2.$slideTrack.children(this.options.slide).detach(),
          i2.$slidesCache.appendTo(i2.$slideTrack),
          i2.reinit());
      }),
    (e.prototype.unload = function () {
      var e2 = this;
      i(".slick-cloned", e2.$slider).remove(),
        e2.$dots && e2.$dots.remove(),
        e2.$prevArrow &&
          e2.htmlExpr.test(e2.options.prevArrow) &&
          e2.$prevArrow.remove(),
        e2.$nextArrow &&
          e2.htmlExpr.test(e2.options.nextArrow) &&
          e2.$nextArrow.remove(),
        e2.$slides
          .removeClass("slick-slide slick-active slick-visible slick-current")
          .attr("aria-hidden", "true")
          .css("width", "");
    }),
    (e.prototype.unslick = function (i2) {
      var e2 = this;
      e2.$slider.trigger("unslick", [e2, i2]), e2.destroy();
    }),
    (e.prototype.updateArrows = function () {
      var i2 = this;
      Math.floor(i2.options.slidesToShow / 2),
        i2.options.arrows === !0 &&
          i2.slideCount > i2.options.slidesToShow &&
          !i2.options.infinite &&
          (i2.$prevArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          i2.$nextArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          i2.currentSlide === 0
            ? (i2.$prevArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              i2.$nextArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"))
            : ((i2.currentSlide >= i2.slideCount - i2.options.slidesToShow &&
                i2.options.centerMode === !1) ||
                (i2.currentSlide >= i2.slideCount - 1 &&
                  i2.options.centerMode === !0)) &&
              (i2.$nextArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              i2.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false")));
    }),
    (e.prototype.updateDots = function () {
      var i2 = this;
      i2.$dots !== null &&
        (i2.$dots.find("li").removeClass("slick-active").end(),
        i2.$dots
          .find("li")
          .eq(Math.floor(i2.currentSlide / i2.options.slidesToScroll))
          .addClass("slick-active"));
    }),
    (e.prototype.visibility = function () {
      var i2 = this;
      i2.options.autoplay &&
        (document[i2.hidden] ? (i2.interrupted = !0) : (i2.interrupted = !1));
    }),
    (i.fn.slick = function () {
      var i2,
        t,
        o = this,
        s = arguments[0],
        n = Array.prototype.slice.call(arguments, 1),
        r = o.length;
      for (i2 = 0; i2 < r; i2++)
        if (
          (typeof s == "object" || s === void 0
            ? (o[i2].slick = new e(o[i2], s))
            : (t = o[i2].slick[s].apply(o[i2].slick, n)),
          t !== void 0)
        )
          return t;
      return o;
    });
}),
  (function (factory) {
    "use strict";
    typeof define == "function" && define.amd
      ? define(["jquery"], factory)
      : typeof exports < "u"
      ? (module.exports = factory(require("jquery")))
      : factory(jQuery);
  })(function ($2) {
    ($2.fn.marquee = function (options) {
      return this.each(function () {
        var o = $2.extend({}, $2.fn.marquee.defaults, options),
          $this = $2(this),
          $marqueeWrapper,
          containerWidth,
          animationCss,
          verticalDir,
          elWidth,
          loopCount = 3,
          playState = "animation-play-state",
          css3AnimationIsSupported = !1,
          _prefixedEvent = function (element, type, callback) {
            for (
              var pfx = ["webkit", "moz", "MS", "o", ""], p = 0;
              p < pfx.length;
              p++
            )
              pfx[p] || (type = type.toLowerCase()),
                element.addEventListener(pfx[p] + type, callback, !1);
          },
          _objToString = function (obj) {
            var tabjson = [];
            for (var p in obj)
              obj.hasOwnProperty(p) && tabjson.push(p + ":" + obj[p]);
            return tabjson.push(), "{" + tabjson.join(",") + "}";
          },
          _startAnimationWithDelay = function () {
            $this.timer = setTimeout(animate, o.delayBeforeStart);
          },
          methods = {
            pause: function () {
              css3AnimationIsSupported && o.allowCss3Support
                ? $marqueeWrapper.css(playState, "paused")
                : $2.fn.pause && $marqueeWrapper.pause(),
                $this.data("runningStatus", "paused"),
                $this.trigger("paused");
            },
            resume: function () {
              css3AnimationIsSupported && o.allowCss3Support
                ? $marqueeWrapper.css(playState, "running")
                : $2.fn.resume && $marqueeWrapper.resume(),
                $this.data("runningStatus", "resumed"),
                $this.trigger("resumed");
            },
            toggle: function () {
              methods[
                $this.data("runningStatus") === "resumed" ? "pause" : "resume"
              ]();
            },
            destroy: function () {
              clearTimeout($this.timer),
                $this.find("*").addBack().off(),
                $this.html($this.find(".js-marquee:first").html());
            },
          };
        if (typeof options == "string") {
          $2.isFunction(methods[options]) &&
            ($marqueeWrapper ||
              ($marqueeWrapper = $this.find(".js-marquee-wrapper")),
            $this.data("css3AnimationIsSupported") === !0 &&
              (css3AnimationIsSupported = !0),
            methods[options]());
          return;
        }
        var dataAttributes = {},
          attr;
        $2.each(o, function (key) {
          if (((attr = $this.attr("data-" + key)), typeof attr < "u")) {
            switch (attr) {
              case "true":
                attr = !0;
                break;
              case "false":
                attr = !1;
                break;
            }
            o[key] = attr;
          }
        }),
          o.speed &&
            (o.duration = (parseInt($this.width(), 10) / o.speed) * 1e3),
          (verticalDir = o.direction === "up" || o.direction === "down"),
          (o.gap = o.duplicated ? parseInt(o.gap) : 0),
          $this.wrapInner('<div class="js-marquee"></div>');
        var $el = $this
          .find(".js-marquee")
          .css({ "margin-right": o.gap, float: "left" });
        if (
          (o.duplicated && $el.clone(!0).appendTo($this),
          $this.wrapInner(
            '<div style="width:100000px" class="js-marquee-wrapper"></div>'
          ),
          ($marqueeWrapper = $this.find(".js-marquee-wrapper")),
          verticalDir)
        ) {
          var containerHeight = $this.height();
          $marqueeWrapper.removeAttr("style"),
            $this.height(containerHeight),
            $this
              .find(".js-marquee")
              .css({
                float: "none",
                "margin-bottom": o.gap,
                "margin-right": 0,
              }),
            o.duplicated &&
              $this.find(".js-marquee:last").css({ "margin-bottom": 0 });
          var elHeight = $this.find(".js-marquee:first").height() + o.gap;
          o.startVisible && !o.duplicated
            ? ((o._completeDuration =
                ((parseInt(elHeight, 10) + parseInt(containerHeight, 10)) /
                  parseInt(containerHeight, 10)) *
                o.duration),
              (o.duration =
                (parseInt(elHeight, 10) / parseInt(containerHeight, 10)) *
                o.duration))
            : (o.duration =
                ((parseInt(elHeight, 10) + parseInt(containerHeight, 10)) /
                  parseInt(containerHeight, 10)) *
                o.duration);
        } else (elWidth = $this.find(".js-marquee:first").width() + o.gap), (containerWidth = $this.width()), o.startVisible && !o.duplicated ? ((o._completeDuration = ((parseInt(elWidth, 10) + parseInt(containerWidth, 10)) / parseInt(containerWidth, 10)) * o.duration), (o.duration = (parseInt(elWidth, 10) / parseInt(containerWidth, 10)) * o.duration)) : (o.duration = ((parseInt(elWidth, 10) + parseInt(containerWidth, 10)) / parseInt(containerWidth, 10)) * o.duration);
        if (
          (o.duplicated && (o.duration = o.duration / 2), o.allowCss3Support)
        ) {
          var elm = document.body || document.createElement("div"),
            animationName =
              "marqueeAnimation-" + Math.floor(Math.random() * 1e7),
            domPrefixes = "Webkit Moz O ms Khtml".split(" "),
            animationString = "animation",
            animationCss3Str = "",
            keyframeString = "";
          if (
            (elm.style.animation !== void 0 &&
              ((keyframeString = "@keyframes " + animationName + " "),
              (css3AnimationIsSupported = !0)),
            css3AnimationIsSupported === !1)
          ) {
            for (var i = 0; i < domPrefixes.length; i++)
              if (elm.style[domPrefixes[i] + "AnimationName"] !== void 0) {
                var prefix = "-" + domPrefixes[i].toLowerCase() + "-";
                (animationString = prefix + animationString),
                  (playState = prefix + playState),
                  (keyframeString =
                    "@" + prefix + "keyframes " + animationName + " "),
                  (css3AnimationIsSupported = !0);
                break;
              }
          }
          css3AnimationIsSupported &&
            ((animationCss3Str =
              animationName +
              " " +
              o.duration / 1e3 +
              "s " +
              o.delayBeforeStart / 1e3 +
              "s infinite " +
              o.css3easing),
            $this.data("css3AnimationIsSupported", !0));
        }
        var _rePositionVertically = function () {
            $marqueeWrapper.css(
              "transform",
              "translateY(" +
                (o.direction === "up"
                  ? containerHeight + "px"
                  : "-" + elHeight + "px") +
                ")"
            );
          },
          _rePositionHorizontally = function () {
            $marqueeWrapper.css(
              "transform",
              "translateX(" +
                (o.direction === "left"
                  ? containerWidth + "px"
                  : "-" + elWidth + "px") +
                ")"
            );
          };
        o.duplicated
          ? (verticalDir
              ? o.startVisible
                ? $marqueeWrapper.css("transform", "translateY(0)")
                : $marqueeWrapper.css(
                    "transform",
                    "translateY(" +
                      (o.direction === "up"
                        ? containerHeight + "px"
                        : "-" + (elHeight * 2 - o.gap) + "px") +
                      ")"
                  )
              : o.startVisible
              ? $marqueeWrapper.css("transform", "translateX(0)")
              : $marqueeWrapper.css(
                  "transform",
                  "translateX(" +
                    (o.direction === "left"
                      ? containerWidth + "px"
                      : "-" + (elWidth * 2 - o.gap) + "px") +
                    ")"
                ),
            o.startVisible || (loopCount = 1))
          : o.startVisible
          ? (loopCount = 2)
          : verticalDir
          ? _rePositionVertically()
          : _rePositionHorizontally();
        var animate = function () {
          if (
            (o.duplicated &&
              (loopCount === 1
                ? ((o._originalDuration = o.duration),
                  verticalDir
                    ? (o.duration =
                        o.direction === "up"
                          ? o.duration +
                            containerHeight / (elHeight / o.duration)
                          : o.duration * 2)
                    : (o.duration =
                        o.direction === "left"
                          ? o.duration + containerWidth / (elWidth / o.duration)
                          : o.duration * 2),
                  animationCss3Str &&
                    (animationCss3Str =
                      animationName +
                      " " +
                      o.duration / 1e3 +
                      "s " +
                      o.delayBeforeStart / 1e3 +
                      "s " +
                      o.css3easing),
                  loopCount++)
                : loopCount === 2 &&
                  ((o.duration = o._originalDuration),
                  animationCss3Str &&
                    ((animationName = animationName + "0"),
                    (keyframeString = $2.trim(keyframeString) + "0 "),
                    (animationCss3Str =
                      animationName +
                      " " +
                      o.duration / 1e3 +
                      "s 0s infinite " +
                      o.css3easing)),
                  loopCount++)),
            verticalDir
              ? o.duplicated
                ? (loopCount > 2 &&
                    $marqueeWrapper.css(
                      "transform",
                      "translateY(" +
                        (o.direction === "up" ? 0 : "-" + elHeight + "px") +
                        ")"
                    ),
                  (animationCss = {
                    transform:
                      "translateY(" +
                      (o.direction === "up" ? "-" + elHeight + "px" : 0) +
                      ")",
                  }))
                : o.startVisible
                ? loopCount === 2
                  ? (animationCss3Str &&
                      (animationCss3Str =
                        animationName +
                        " " +
                        o.duration / 1e3 +
                        "s " +
                        o.delayBeforeStart / 1e3 +
                        "s " +
                        o.css3easing),
                    (animationCss = {
                      transform:
                        "translateY(" +
                        (o.direction === "up"
                          ? "-" + elHeight + "px"
                          : containerHeight + "px") +
                        ")",
                    }),
                    loopCount++)
                  : loopCount === 3 &&
                    ((o.duration = o._completeDuration),
                    animationCss3Str &&
                      ((animationName = animationName + "0"),
                      (keyframeString = $2.trim(keyframeString) + "0 "),
                      (animationCss3Str =
                        animationName +
                        " " +
                        o.duration / 1e3 +
                        "s 0s infinite " +
                        o.css3easing)),
                    _rePositionVertically())
                : (_rePositionVertically(),
                  (animationCss = {
                    transform:
                      "translateY(" +
                      (o.direction === "up"
                        ? "-" + $marqueeWrapper.height() + "px"
                        : containerHeight + "px") +
                      ")",
                  }))
              : o.duplicated
              ? (loopCount > 2 &&
                  $marqueeWrapper.css(
                    "transform",
                    "translateX(" +
                      (o.direction === "left" ? 0 : "-" + elWidth + "px") +
                      ")"
                  ),
                (animationCss = {
                  transform:
                    "translateX(" +
                    (o.direction === "left" ? "-" + elWidth + "px" : 0) +
                    ")",
                }))
              : o.startVisible
              ? loopCount === 2
                ? (animationCss3Str &&
                    (animationCss3Str =
                      animationName +
                      " " +
                      o.duration / 1e3 +
                      "s " +
                      o.delayBeforeStart / 1e3 +
                      "s " +
                      o.css3easing),
                  (animationCss = {
                    transform:
                      "translateX(" +
                      (o.direction === "left"
                        ? "-" + elWidth + "px"
                        : containerWidth + "px") +
                      ")",
                  }),
                  loopCount++)
                : loopCount === 3 &&
                  ((o.duration = o._completeDuration),
                  animationCss3Str &&
                    ((animationName = animationName + "0"),
                    (keyframeString = $2.trim(keyframeString) + "0 "),
                    (animationCss3Str =
                      animationName +
                      " " +
                      o.duration / 1e3 +
                      "s 0s infinite " +
                      o.css3easing)),
                  _rePositionHorizontally())
              : (_rePositionHorizontally(),
                (animationCss = {
                  transform:
                    "translateX(" +
                    (o.direction === "left"
                      ? "-" + elWidth + "px"
                      : containerWidth + "px") +
                    ")",
                })),
            $this.trigger("beforeStarting"),
            css3AnimationIsSupported)
          ) {
            $marqueeWrapper.css(animationString, animationCss3Str);
            var keyframeCss =
                keyframeString + " { 100%  " + _objToString(animationCss) + "}",
              $styles = $marqueeWrapper.find("style");
            $styles.length !== 0
              ? $styles.filter(":last").html(keyframeCss)
              : $2("head").append("<style>" + keyframeCss + "</style>"),
              _prefixedEvent(
                $marqueeWrapper[0],
                "AnimationIteration",
                function () {
                  $this.trigger("finished");
                }
              ),
              _prefixedEvent($marqueeWrapper[0], "AnimationEnd", function () {
                animate(), $this.trigger("finished");
              });
          } else
            $marqueeWrapper.animate(
              animationCss,
              o.duration,
              o.easing,
              function () {
                $this.trigger("finished"),
                  o.pauseOnCycle ? _startAnimationWithDelay() : animate();
              }
            );
          $this.data("runningStatus", "resumed");
        };
        $this.on("pause", methods.pause),
          $this.on("resume", methods.resume),
          o.pauseOnHover &&
            ($this.on("mouseenter", methods.pause),
            $this.on("mouseleave", methods.resume)),
          css3AnimationIsSupported && o.allowCss3Support
            ? animate()
            : _startAnimationWithDelay();
      });
    }),
      ($2.fn.marquee.defaults = {
        allowCss3Support: !0,
        css3easing: "linear",
        easing: "linear",
        delayBeforeStart: 1e3,
        direction: "left",
        duplicated: !1,
        duration: 5e3,
        speed: 0,
        gap: 20,
        pauseOnCycle: !1,
        pauseOnHover: !1,
        startVisible: !1,
      });
  });
function isSafari() {
  return /^((?!chrome).)*safari/i.test(navigator.userAgent);
}
navigator.userAgent.indexOf("Mac") > 1 && $("html").addClass("safari_active"),
  $(".activate_slider .custom_collections_grid").slick({
    dots: !1,
    infinite: !1,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow:
      "<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/1051/1618/files/left.svg?v=1697016813'>",
    nextArrow:
      "<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/1051/1618/files/right.svg?v=1697016813'>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: !0,
          dots: !0,
        },
      },
      { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  }),
  $(".style_type_gallery_main").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: !0,
    prevArrow:
      "<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/1051/1618/files/left.svg?v=1697016813'>",
    nextArrow:
      "<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/1051/1618/files/right.svg?v=1697016813'>",
    fade: !1,
    infinite: !0,
    useTransform: !0,
    cssEase: "cubic-bezier(0.77, 0, 0.18, 1)",
  }),
  $(".style_type_gallery_thumb")
    .on("init", function (event, slick) {
      $(this)
        .parent(".style_type_gallery_images")
        .find(".style_type_gallery_thumb")
        .find(".slick-slide.slick-current")
        .addClass("is-active");
    })
    .slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      dots: !1,
      arrows: !1,
      focusOnSelect: !0,
      infinite: !1,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 5, slidesToScroll: 1 } },
        { breakpoint: 640, settings: { slidesToShow: 4, slidesToScroll: 1 } },
        { breakpoint: 420, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      ],
    }),
  $(".style_type_gallery_main").on(
    "afterChange",
    function (event, slick, currentSlide) {
      $(this)
        .parents(".style_type_gallery_images")
        .find(".style_type_gallery_thumb")
        .slick("slickGoTo", currentSlide);
      var currrentNavSlideElem =
        '.slick-slide[data-slick-index="' + currentSlide + '"]';
      $(this)
        .parents(".style_type_gallery_images")
        .find(".style_type_gallery_thumb")
        .find(".slick-slide.is-active")
        .removeClass("is-active"),
        $(this)
          .parents(".style_type_gallery_images")
          .find(".style_type_gallery_thumb")
          .find(currrentNavSlideElem)
          .addClass("is-active");
    }
  ),
  $(".style_type_gallery_thumb").on("click", ".slick-slide", function (event) {
    event.preventDefault();
    var goToSingleSlide = $(this).data("slick-index");
    $(this)
      .parents(".style_type_gallery_images")
      .find(".style_type_gallery_main")
      .slick("slickGoTo", goToSingleSlide);
  }),
  $(window).width() < 769
    ? ($(".custom_testimonial_grid").slick({
        dots: !0,
        infinite: !1,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow:
          "<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/1051/1618/files/left.svg?v=1697016813'>",
        nextArrow:
          "<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/1051/1618/files/right.svg?v=1697016813'>",
      }),
      $(".blogs_section_index .blog__posts.articles-wrapper").slick({
        dots: !1,
        infinite: !1,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow:
          "<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/1051/1618/files/left.svg?v=1697016813'>",
        nextArrow:
          "<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/1051/1618/files/right.svg?v=1697016813'>",
        adaptiveHeight: !0,
      }),
      $(".marquee-bg ul").marquee({
        speed: 35,
        gap: 50,
        delayBeforeStart: 0,
        direction: "left",
        startVisible: !0,
        duplicated: !0,
      }),
      $(".marquee-bg_right ul").marquee({
        speed: 35,
        gap: 50,
        delayBeforeStart: 0,
        direction: "right",
        startVisible: !0,
        duplicated: !0,
      }))
    : ($(".marquee-bg ul").marquee({
        speed: 45,
        gap: 50,
        delayBeforeStart: 0,
        direction: "left",
        startVisible: !0,
        duplicated: !0,
      }),
      $(".marquee-bg_right ul").marquee({
        speed: 45,
        gap: 50,
        delayBeforeStart: 0,
        direction: "right",
        startVisible: !0,
        duplicated: !0,
      })),
  $(".custom_main_product_images").slick({
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:
      "<img class='a-left control-c prev slick-prev' src='https://cdn.shopify.com/s/files/1/1051/1618/files/left.svg?v=1697016813'>",
    nextArrow:
      "<img class='a-right control-c next slick-next' src='https://cdn.shopify.com/s/files/1/1051/1618/files/right.svg?v=1697016813'>",
  }),
  $(".product_info_accordions_trigger").click(function () {
    $(this).toggleClass("open").next().slideToggle("fast"),
      $(this)
        .parent()
        .siblings()
        .find(".product_info_accordions_trigger")
        .removeClass("open")
        .next()
        .slideUp("fast");
  }),
  $(".custom_main_product_lining").click(function () {
    $(this).next().addClass("open"),
      $(".buylining_popup_overlay").click(function () {
        $(this).parent().removeClass("open");
      });
  }),
  $(
    ".temp_product-valances .custom_options_selection_input,.temp_product .custom_options_selection_input,.temp_product-victoria_tassel_trim .custom_options_selection_input"
  ).change(function () {
    let thisthus = $(this);
    thisthus
      .parents(".custom_main_product_info")
      .find(".all_line_items_properties")
      .html("");
    let total = "";
    $(this).val() == "notselected"
      ? $(this).parent().removeClass("active")
      : $(this).parent().addClass("active");
    let check = 0,
      c = "";
    $(this)
      .parents(".custom_options_selection")
      .find(".custom_options_selection_input:not(.notcount)")
      .each(function () {
        c += $(this).find("option:selected").data("val");
      }),
      $(this)
        .parents(".custom_options_selection")
        .find(".custom_options_selection_input")
        .each(function () {
          $(this).val() == "notselected" && (check = check + 1);
        }),
      (total = thisthus
        .parents(".custom_options_selection")
        .next(".price_checker")
        .find(`option[value=${c}]`)
        .data("price"));
    let id = thisthus
      .parents(".custom_options_selection")
      .next(".price_checker")
      .find(`option[value=${c}]`)
      .data("id");
    if (check == 0) {
      let curr = $("select.currency-switcher[name=doubly-currencies]").val();
      curr == "GBP"
        ? thisthus
            .parents(".custom_options_selection")
            .siblings(".custom_main_product_price_review")
            .find(".only_price")
            .html(
              `<span class="money" doubly-currency-gbp="${
                total * 100
              }" doubly-currency="${curr}" doubly-currency-eur="${
                total * 100 * 1.16
              }">\xA3${total} ${curr}</span></span>`
            )
        : curr == "EUR"
        ? thisthus
            .parents(".custom_options_selection")
            .siblings(".custom_main_product_price_review")
            .find(".only_price")
            .html(
              `<span class="money" doubly-currency-gbp="${
                total * 100
              }" doubly-currency="${curr}" doubly-currency-eur="${
                total * 100 * 1.16
              }">\u20AC${(total * 1.16).toFixed(2)} ${curr}</span></span>`
            )
        : thisthus
            .parents(".custom_options_selection")
            .siblings(".custom_main_product_price_review")
            .find(".only_price")
            .html(
              `<span class="money" doubly-currency-gbp="${
                total * 100
              }" doubly-currency="${curr}" doubly-currency-eur="${
                total * 100 * 1.16
              }">\xA3${total}</span></span>`
            ),
        $(this)
          .parents(".custom_options_selection")
          .find(".custom_options_selection_input")
          .each(function () {
            let z = $(this).attr("name"),
              y = $(this).find("option:selected").text();
            thisthus
              .parents(".custom_main_product_info")
              .find(".all_line_items_properties")
              .append(
                `<input type='hidden' name='properties[${z}]' value='${y}'>`
              );
          }),
        thisthus
          .parents(".custom_main_product_info")
          .find('[name="id"]')
          .val(id),
        thisthus
          .parents(".custom_main_product_info")
          .find(".quick-add__submit")
          .removeAttr("disabled");
    } else thisthus.parents(".custom_main_product_info").find(".quick-add__submit").attr("disabled", !0);
    thisthus
      .parents(".custom_main_product_info")
      .find(".quick-add__submit")
      .attr("data-price", total),
      thisthus
        .parents(".custom_main_product_info")
        .find(".check_kar")
        .attr("data-price", total);
  }),
  $(".drawer__footer .enb_dsb_checkout input").click(function () {
    $(this).is(":checked")
      ? $(this).parent().next().removeAttr("disabled")
      : $(this).parent().next().attr("disabled", !0);
  }),
  $(".cart__footer .enb_dsb_checkout input").click(function () {
    $(this).is(":checked")
      ? ($(this).parent().next().removeAttr("disabled"),
        $(this).parent().parent().next().removeAttr("disabled"))
      : ($(this).parent().next().attr("disabled", !0),
        $(this).parent().parent().next().attr("disabled", !0));
  }),
  hello($(".faqs_side_bar>p:first-child")),
  $(".faqs_side_bar>p").click(function () {
    hello($(this));
  });
function hello(thus) {
  thus.addClass("active").siblings().removeClass("active");
  let v1 = thus.attr("data-categorie");
  thus
    .parent()
    .parent()
    .find(".faqs_questions_item")
    .each(function () {
      let v2 = $(this).attr("data-categorie");
      v1 == v2 ? $(this).show() : $(this).hide();
    });
}
$(".faqs_question").click(function () {
  $(this).toggleClass("open").next().slideToggle("fast"),
    $(this)
      .parent()
      .siblings()
      .find(".faqs_question")
      .removeClass("open")
      .next()
      .slideUp("fast");
}),
  $(".headings_style_guide_main .collection_banner_readmore").click(
    function () {
      $(this).text() == "Read More"
        ? ($(this).text("Read Less"),
          $(this)
            .siblings(".collection_banner_description")
            .find(".coll_long_desc")
            .show()
            .siblings(".coll_short_desc")
            .hide())
        : ($(this).text("Read More"),
          $(this)
            .siblings(".collection_banner_description")
            .find(".coll_long_desc")
            .hide()
            .siblings(".coll_short_desc")
            .show());
    }
  ),
  $(".forcollection .collection_banner_readmore").click(function () {
    $(this).text() == "Read More"
      ? $(this).text("Read Less")
      : $(this).text("Read More"),
      $(this)
        .siblings(".collection_banner_description")
        .find(".coll_short_desc")
        .toggleClass("showfull");
  }),
  hello2($(".heading_styles_side_bar>p:first-child")),
  $(".heading_styles_side_bar>p").click(function () {
    hello2($(this));
  });
function hello2(thus) {
  thus.addClass("active").siblings().removeClass("active");
  let v1 = thus.attr("data-categorie_check");
  thus
    .parent()
    .parent()
    .find("[data-categorie]")
    .each(function () {
      let v2 = $(this).attr("data-categorie");
      v1 == v2 ? $(this).show() : $(this).hide();
    });
}
$(".heading_styles_question").click(function () {
  $(this).toggleClass("open").next().slideToggle("fast"),
    $(this)
      .parent()
      .siblings()
      .find(".heading_styles_question")
      .removeClass("open")
      .next()
      .slideUp("fast");
}),
  $(".measurement_guide_banner_content button").click(function () {
    $(this).hide(),
      $(this)
        .siblings(".measurement_guide_banner_subtext")
        .show()
        .siblings(".measurement_guide_banner_subtext.banner_subtext_short_desc")
        .hide();
  }),
  $(document).ready(function () {
    $(".selected-option").click(function () {
      var $parent = $(this).parents(".custom_options_selection"),
        $options = $parent.find(".options"),
        $search = $parent.find(".selected-search");
      $options.not($(this).parent().find(".options")).slideUp(50),
        $search.not($(this).parent().find(".selected-search")).slideUp(50),
        $(this).parent().find(".options, .selected-search").slideToggle(50);
    }),
      $(".options li").click(function () {
        var selectedValue = $(this).data("comp");
        if (
          ($(this)
            .parents(".custom-select")
            .find(".selected-option")
            .val($(this).text()),
          $(this).parents(".custom-select").find(".options").slideUp(50),
          $(this)
            .parents(".custom-select")
            .find(".selected-search")
            .slideUp(50),
          $(this)
            .parents(".custom_options_selection_field")
            .find(".custom_options_selection_input")
            .val(selectedValue)
            .trigger("change"),
          window.isCurtain === !0 &&
            $(this)
              .parents(".custom-select")
              .find(".selected-option")
              .data("head") === "Select Style")
        ) {
          let grommet_div = $("#grommet_size"),
            select_input = grommet_div.find(".custom_options_selection_input"),
            quickAddSubmit = $(this)
              .parents(".custom_main_product_info")
              .find(".quick-add__submit");
          selectedValue == "Grommet / Eyelet Top"
            ? (grommet_div.removeClass("hidden"),
              select_input.removeClass("hidden"),
              quickAddSubmit.attr("disabled", !0))
            : (grommet_div.addClass("hidden"),
              select_input.addClass("hidden"),
              $(".custom_options_selection_input.grommet_size")
                .val("notselected")
                .trigger("change"),
              grommet_div
                .find(".custom-select")
                .find(".selected-option")
                .val("Select Grommet Size & Finish"));
        }
      }),
      $(document).click(function (e) {
        $(e.target).closest(".custom-select").length ||
          ($(".options").slideUp(50), $(".selected-search").slideUp(50));
      }),
      $(".custom_options_selection_field input.selected-search").on(
        "keyup",
        function (e) {
          let x = $(this).val().toLowerCase();
          $(this)
            .next(".options")
            .find("li")
            .each(function () {
              $(this).attr("data-comp").toLowerCase().includes(x)
                ? $(this).show()
                : $(this).hide();
            });
        }
      );
    function calculateTotal($element) {
      let c = "";
      return (
        $element
          .find(".custom_options_selection_input:not(.notcount)")
          .each(function () {
            c += $(this).find("option:selected").data("val");
          }),
        c
      );
    }
    function calculateCheck($element) {
      let check = 0;
      return (
        $element
          .find(".custom_options_selection_input:not(.hidden)")
          .each(function () {
            $(this).val() === "notselected" && check++;
          }),
        check
      );
    }
//     $(
//       ".temp_product-trim_template1, .temp_product-trim_template2, .temp_product-valance_template2, .temp_product-curtain_template, .temp_product-runner_template"
//     ).on("change", ".custom_options_selection_input", function () {
//       let $this = $(this),
//         $parentInfo = $this.parents(".custom_main_product_info"),
//         $allLineItemsProperties = $parentInfo.find(
//           ".all_line_items_properties"
//         ),
//         $customOptionsSelection = $this.parents(".custom_options_selection"),
//         $priceChecker = $customOptionsSelection
//           .closest(".custom_main_product_info")
//           .find(".price_checker"),
//         $priceReview = $customOptionsSelection.siblings(
//           ".custom_main_product_price_review"
//         ),
//         $quickAddSubmit = $parentInfo.find(".quick-add__submit"),
//         idInput = $parentInfo.find('[name="id"]'),
//         total = $priceChecker
//           .find(`option[value='${calculateTotal($customOptionsSelection)}']`)
//           .data("price"),
//         id = $priceChecker
//           .find(`option[value='${calculateTotal($customOptionsSelection)}']`)
//           .data("id"),
//         countcheck = calculateCheck($customOptionsSelection);

        

//       id == null && countcheck === 0
//         ? ((countcheck = countcheck + 1),
//           $(".prdnotavalable_error").show(),
//           $this.parent().removeClass("active"))
//         : ((countcheck = calculateCheck($customOptionsSelection)),
//           $(".prdnotavalable_error").hide(),
//           $this.val() === "notselected"
//             ? $this.parent().removeClass("active")
//             : $this.parent().addClass("active")),
//         countcheck === 0
//           ? ($allLineItemsProperties.html(""),
//             $priceReview.find(".only_price").html(total),
//             $customOptionsSelection
//               .find(".custom_options_selection_input")
//               .each(function () {
//                 consolelog('cehck input', $(this));
//                 let name = $(this).attr("name"),
//                   value = $(this).find("option:selected").text();
// console.log($(this), name);

//                   if ($(this).hasClass("hidden")) {
//                     return;
//                   }
//                 $allLineItemsProperties.append(
//                   `<input type='hidden' name='properties[${name}]' value='${value}'>`
//                 );
//               }),
//             idInput.val(id),
//             $quickAddSubmit.removeAttr("disabled"))
//           : $quickAddSubmit.attr("disabled", !0),
//         $quickAddSubmit.attr("data-price", total),
//         $parentInfo.find(".check_kar").attr("data-price", total);
//     });


   $(".temp_product-trim_template1, \
  .temp_product-trim_template2, \
  .temp_product-valance_template2, \
  .temp_product-curtain_template, \
  .temp_product-curtain_old_template, \
  .temp_product, \
  .temp_product-runner_template"
).on("change", ".custom_options_selection_input", function () {

  let $this = $(this);
  let $parentInfo = $this.parents(".custom_main_product_info");
  let $allLineItemsProperties = $parentInfo.find(".all_line_items_properties");
  let $customOptionsSelection = $this.parents(".custom_options_selection");
  let $priceReview = $customOptionsSelection.siblings(".custom_main_product_price_review");
  let $quickAddSubmit = $parentInfo.find(".quick-add__submit");
  let idInput = $parentInfo.find('[name="id"]');

  // Store default price if not already stored
  if (!$priceReview.find(".only_price").data("default-price")) {
    $priceReview.find(".only_price").attr("data-default-price", $priceReview.find(".only_price").html());
  }

  let total = $parentInfo.find(".price_checker option[value='" + calculateTotal($customOptionsSelection) + "']").data("price");
  let id = $parentInfo.find(".price_checker option[value='" + calculateTotal($customOptionsSelection) + "']").data("id");
  let countcheck = calculateCheck($customOptionsSelection);

  // Availability Check
  if (id == null && countcheck === 0) {
    countcheck += 1;
    $(".prdnotavalable_error").show();
    $this.parent().removeClass("active");
  } else {
    countcheck = calculateCheck($customOptionsSelection);
    $(".prdnotavalable_error").hide();
    $this.val() === "notselected" ? $this.parent().removeClass("active") : $this.parent().addClass("active");
  }

  // Check if all selects are "notselected"
  let allNotSelected = true;
  $customOptionsSelection.find(".custom_options_selection_input").each(function() {
    if ($(this).val() !== "notselected") {
      allNotSelected = false;
      return false;
    }
  });

  if (allNotSelected) {
    // Reset the product block dynamically
    $allLineItemsProperties.html("");
    $priceReview.find(".only_price").html($priceReview.find(".only_price").data("default-price"));
    idInput.val("");
    $quickAddSubmit.attr("disabled", true);

    $customOptionsSelection.find(".custom_options_selection_input").each(function() {
      $(this).val("notselected").parent().removeClass("active");
    });

    $quickAddSubmit.attr("data-price", 0);
    $parentInfo.find(".check_kar").attr("data-price", 0);

    // --- NEW PART: Refresh product block via AJAX ---
    if (typeof refreshProductBlock === "function") {
      refreshProductBlock($parentInfo);
    } else {
      // fallback: simulate a reload by triggering a change on parent
      $parentInfo.trigger("productReset");
    }

  } else if (countcheck === 0) {
    $allLineItemsProperties.html("");
    $customOptionsSelection.find(".custom_options_selection_input").each(function () {
      if ($(this).hasClass("hidden")) return;
      let name = $(this).attr("name");
      let value = $(this).find("option:selected").text();
      $allLineItemsProperties.append(`<input type='hidden' name='properties[${name}]' value='${value}'>`);
    });
    $priceReview.find(".only_price").html(total);
    idInput.val(id);
    $quickAddSubmit.removeAttr("disabled");
    $quickAddSubmit.attr("data-price", total);
    $parentInfo.find(".check_kar").attr("data-price", total);
  } else {
    $quickAddSubmit.attr("disabled", true);
  }

});

  }),








  $(".style_type_gallery_overlay,.gallery_close_btn").click(function () {
    $(this).parents(".heading_style_type_gallery").removeClass("open"),
      $("body").removeClass("overflow-hidden"),
      $(this)
        .parents(".heading_style_type_gallery")
        .find(".style_type_gallery_main")
        .slick("slickGoTo", 0);
  }),
  $(".custom_main_product_freesample:not(.shop_curtains)>a").click(function (
    e
  ) {
    e.preventDefault(),
      $(this).parent().next().find(".quick-add__submit").trigger("click");
  }),
  $("span.close_fillter").click(function () {
    $(this).parents(".disclosure-has-popup").find("summary").trigger("click");
  });
//# sourceMappingURL=/cdn/shop/t/59/assets/custom.js.map?v=171093968963017882151768367367




// $(document).on("submit", "product-form form", function () {

//   const $form = $(this);

//   setTimeout(function () {


//     $form.find(".custom_options_selection_input").val("notselected");


//     $form.find(".selected-option").each(function () {
//       const defaultText = $(this).attr("data-head") || "Select Option";
//       $(this).val(defaultText);
//     });


//     $form.find(".custom_options_selection_input").parent().removeClass("active");


//     $form.find(".all_line_items_properties").html("");


//     const defaultVariant = $form.find('[name="id"]').data("default") || "";
//     $form.find('[name="id"]').val(defaultVariant).prop("disabled", true);


//     $form
//       .closest(".custom_main_product_info")
//       .find(".only_price")
//       .html("From");


//     $form.find(".quick-add__submit").attr("disabled", true);


//     $form.find(".custom_quantity__input").val(1);


//     $("#grommet_size").addClass("hidden");
//     $("#grommet-select").val("notselected").prop("disabled", true);

//     console.log("Custom product form reset");

//   }, 1200); 

// });

$(document).on('click', '.selected-option', function () {

  // only after add to cart reset
  if ($('body').hasClass('reset-dropdown-scroll')) {

    setTimeout(function () {

      $('.options:visible').each(function () {

        this.scrollTo({
          top: 0,
          behavior: 'instant'
        });

      });

    }, 200);

  }

});





$('.custom_share_popup_button').click(function() {
    $(this).closest('.custom_share_popup').toggleClass('shareactive');
    })
    $(document).on('click', function(event) {
            var $container = $('.shre-btn');
            if (!$container.is(event.target) && $container.has(event.target).length === 0) {
                $container.find('.custom_share_popup').removeClass('shareactive');  // Hides the container
            }
        });


// Dropdown Search Input Reset Functionality
$(document).on('click', '.quick-add__submit', function(){

    console.log('clicked');

    setTimeout(function(){

        console.log('resetting');

        $('.selected-search').val('');
        $('.options li').show();

    }, 2000);

});